// src/i18n.js

export const LANGS = [
  { code: "en", name: "English" },
  { code: "es", name: "Spanish" },
  { code: "pt", name: "Portuguese" },
  { code: "de", name: "German" },
  { code: "fr", name: "French" },
  { code: "nl", name: "Dutch" },
];

const STRINGS = {
  en: {
    appTitle: "FlagIQ",
    appSubtitle: "Test your world knowledge — one flag at a time",
    homeInfoTitle: "How to Play",
    homeInfoBody:
      "🎯 Goal: Identify the correct country for each flag. The faster and more accurate you are, the better your score.\n\n🎮 Game Modes:\n• Classic Mode: Play at your own pace with no timer pressure.\n• Time Trial: Race against the clock where both speed and accuracy matter; faster correct answers earn higher scores.\n• Local Flags: Explore regional packs like US states and master local flags.\n\n❤️ Lives System: You lose one life each time you fail to successfully complete a level. Lives automatically refill over time.\n\n💡 Hints & Boosters:\n• Remove 2: Eliminates two incorrect options.\n• Auto Pass: Instantly completes the flag and moves you forward.\n• Pause Timer: Freezes the Time Trial clock for 3 seconds.\n\n⭐ Stars & Progress: Earn up to three stars per level based on your performance. Collect stars to unlock new levels, regions, and special flag packs.\n\n🪙 Coins & Rewards: Completing a level for the first time earns coins. Spend them in the shop on hints and boosters to advance faster.\n\n🎁 Daily Booster: Open a free booster box every 24 hours to receive hints and boosts.",
    homeLeaderboardTitle: "Leaderboard",
    homeLeaderboardBody:
      "The global leaderboard is on the way. Stay tuned for competitive rankings.",
    leaderboardTopLabel: "Top 100 Players • Total Points",
    leaderboardLoading: "Loading leaderboard...",
    leaderboardError: "Unable to load leaderboard right now.",
    leaderboardEmpty: "No Time Trial scores yet.",
    leaderboardLoginRequired: "Leaderboard is available for logged in users only.",
    "homeInfo.goal.title": "Goal",
    "homeInfo.goal.body": "Identify the correct country for each flag. The faster and more accurate you are, the better your score.",
    "homeInfo.modes.title": "Game Modes",
    "homeInfo.modes.classic": "Classic Mode: Play at your own pace with no timer pressure.",
    "homeInfo.modes.timetrial": "Time Trial: Race against the clock where both speed and accuracy matter; faster correct answers earn higher scores.",
    "homeInfo.modes.local": "Local Flags: Explore regional packs like US states and master local flags.",
    "homeInfo.lives.title": "Lives System",
    "homeInfo.lives.body": "You lose one life each time you fail to successfully complete a level. Lives automatically refill over time.",
    "homeInfo.hints.title": "Hints & Boosters",
    "homeInfo.hints.remove2.label": "Remove 2",
    "homeInfo.hints.remove2.body": "Eliminates two incorrect options.",
    "homeInfo.hints.autopass.label": "Auto Pass",
    "homeInfo.hints.autopass.body": "Instantly completes the flag and moves you forward.",
    "homeInfo.hints.pause.label": "Pause Timer",
    "homeInfo.hints.pause.body": "Freezes the Time Trial clock for 3 seconds.",
    "homeInfo.stars.title": "Stars & Progress",
    "homeInfo.stars.body": "Earn up to three stars per level based on your performance. Collect stars to unlock new levels, regions, and special flag packs.",
    "homeInfo.coins.title": "Coins & Rewards",
    "homeInfo.coins.body": "Completing a level for the first time earns coins. Spend them in the shop on hints and boosters to advance faster.",
    "homeInfo.daily.title": "Daily Booster",
    "homeInfo.daily.body": "Open a free booster box every 24 hours to receive hints and boosts.",
    "leaderboard.attempts.one": "{{count}} attempt",
    "leaderboard.attempts.other": "{{count}} attempts",

    classic: "Classic",
    classicDesc: "Learn flags at your pace",
    timeTrial: "Time Trial",
    timeTrialDesc: "Beat the timer!",
    comingSoon: "Coming soon",
    localFlags: "Local Flags",
    localFlagsDesc: "Expert players only",
    "localFlags.packs.all.name": "All Local Flags",
    "localFlags.packs.all.short": "All",
    "localFlags.packs.ch.name": "Switzerland",
    "localFlags.packs.de.name": "Germany",
    "localFlags.packs.es.name": "Spain",
    "localFlags.packs.gb.name": "United Kingdom",
    "localFlags.packs.us.name": "United States",
    "localFlags.subdivisions.ch_ag.name": "Aargau",
    "localFlags.subdivisions.ch_ai.name": "Appenzell Innerrhoden",
    "localFlags.subdivisions.ch_ar.name": "Appenzell Ausserrhoden",
    "localFlags.subdivisions.ch_be.name": "Bern",
    "localFlags.subdivisions.ch_bl.name": "Basel-Landschaft",
    "localFlags.subdivisions.ch_bs.name": "Basel-Stadt",
    "localFlags.subdivisions.ch_fr.name": "Fribourg",
    "localFlags.subdivisions.ch_ge.name": "Geneva",
    "localFlags.subdivisions.ch_gl.name": "Glarus",
    "localFlags.subdivisions.ch_gr.name": "Graubünden",
    "localFlags.subdivisions.ch_ju.name": "Jura",
    "localFlags.subdivisions.ch_lu.name": "Lucerne",
    "localFlags.subdivisions.ch_ne.name": "Neuchâtel",
    "localFlags.subdivisions.ch_nw.name": "Nidwalden",
    "localFlags.subdivisions.ch_ow.name": "Obwalden",
    "localFlags.subdivisions.ch_sg.name": "St. Gallen",
    "localFlags.subdivisions.ch_sh.name": "Schaffhausen",
    "localFlags.subdivisions.ch_so.name": "Solothurn",
    "localFlags.subdivisions.ch_sz.name": "Schwyz",
    "localFlags.subdivisions.ch_tg.name": "Thurgau",
    "localFlags.subdivisions.ch_ti.name": "Ticino",
    "localFlags.subdivisions.ch_ur.name": "Uri",
    "localFlags.subdivisions.ch_vd.name": "Vaud",
    "localFlags.subdivisions.ch_vs.name": "Valais",
    "localFlags.subdivisions.ch_zg.name": "Zug",
    "localFlags.subdivisions.ch_zh.name": "Zürich",
    "localFlags.subdivisions.es_an.name": "Andalusia",
    "localFlags.subdivisions.es_ar.name": "Aragon",
    "localFlags.subdivisions.es_as.name": "Asturias",
    "localFlags.subdivisions.es_ib.name": "Balearic Islands",
    "localFlags.subdivisions.es_pv.name": "Basque Country",
    "localFlags.subdivisions.es_cn.name": "Canary Islands",
    "localFlags.subdivisions.es_cb.name": "Cantabria",
    "localFlags.subdivisions.es_cl.name": "Castile and León",
    "localFlags.subdivisions.es_cm.name": "Castile-La Mancha",
    "localFlags.subdivisions.es_ct.name": "Catalonia",
    "localFlags.subdivisions.es_ex.name": "Extremadura",
    "localFlags.subdivisions.es_ga.name": "Galicia",
    "localFlags.subdivisions.es_ri.name": "La Rioja",
    "localFlags.subdivisions.es_md.name": "Madrid",
    "localFlags.subdivisions.es_mc.name": "Murcia",
    "localFlags.subdivisions.es_nc.name": "Navarre",
    "localFlags.subdivisions.es_vc.name": "Valencia",
    "localFlags.subdivisions.de_bw.name": "Baden-Württemberg",
    "localFlags.subdivisions.de_by.name": "Bavaria",
    "localFlags.subdivisions.de_be.name": "Berlin",
    "localFlags.subdivisions.de_bb.name": "Brandenburg",
    "localFlags.subdivisions.de_hb.name": "Bremen",
    "localFlags.subdivisions.de_hh.name": "Hamburg",
    "localFlags.subdivisions.de_he.name": "Hesse",
    "localFlags.subdivisions.de_ni.name": "Lower Saxony",
    "localFlags.subdivisions.de_mv.name": "Mecklenburg-Vorpommern",
    "localFlags.subdivisions.de_nw.name": "North Rhine-Westphalia",
    "localFlags.subdivisions.de_rp.name": "Rhineland-Palatinate",
    "localFlags.subdivisions.de_sl.name": "Saarland",
    "localFlags.subdivisions.de_sn.name": "Saxony",
    "localFlags.subdivisions.de_st.name": "Saxony-Anhalt",
    "localFlags.subdivisions.de_sh.name": "Schleswig-Holstein",
    "localFlags.subdivisions.de_th.name": "Thuringia",
    "localFlags.subdivisions.us_al.name": "Alabama",
    "localFlags.subdivisions.us_ak.name": "Alaska",
    "localFlags.subdivisions.us_az.name": "Arizona",
    "localFlags.subdivisions.us_ar.name": "Arkansas",
    "localFlags.subdivisions.us_ca.name": "California",
    "localFlags.subdivisions.us_co.name": "Colorado",
    "localFlags.subdivisions.us_ct.name": "Connecticut",
    "localFlags.subdivisions.us_de.name": "Delaware",
    "localFlags.subdivisions.us_fl.name": "Florida",
    "localFlags.subdivisions.us_ga.name": "Georgia",
    "localFlags.subdivisions.us_hi.name": "Hawaii",
    "localFlags.subdivisions.us_id.name": "Idaho",
    "localFlags.subdivisions.us_il.name": "Illinois",
    "localFlags.subdivisions.us_in.name": "Indiana",
    "localFlags.subdivisions.us_ia.name": "Iowa",
    "localFlags.subdivisions.us_ks.name": "Kansas",
    "localFlags.subdivisions.us_ky.name": "Kentucky",
    "localFlags.subdivisions.us_la.name": "Louisiana",
    "localFlags.subdivisions.us_me.name": "Maine",
    "localFlags.subdivisions.us_md.name": "Maryland",
    "localFlags.subdivisions.us_ma.name": "Massachusetts",
    "localFlags.subdivisions.us_mi.name": "Michigan",
    "localFlags.subdivisions.us_mn.name": "Minnesota",
    "localFlags.subdivisions.us_ms.name": "Mississippi",
    "localFlags.subdivisions.us_mo.name": "Missouri",
    "localFlags.subdivisions.us_mt.name": "Montana",
    "localFlags.subdivisions.us_ne.name": "Nebraska",
    "localFlags.subdivisions.us_nv.name": "Nevada",
    "localFlags.subdivisions.us_nh.name": "New Hampshire",
    "localFlags.subdivisions.us_nj.name": "New Jersey",
    "localFlags.subdivisions.us_nm.name": "New Mexico",
    "localFlags.subdivisions.us_ny.name": "New York",
    "localFlags.subdivisions.us_nc.name": "North Carolina",
    "localFlags.subdivisions.us_nd.name": "North Dakota",
    "localFlags.subdivisions.us_oh.name": "Ohio",
    "localFlags.subdivisions.us_ok.name": "Oklahoma",
    "localFlags.subdivisions.us_or.name": "Oregon",
    "localFlags.subdivisions.us_pa.name": "Pennsylvania",
    "localFlags.subdivisions.us_ri.name": "Rhode Island",
    "localFlags.subdivisions.us_sc.name": "South Carolina",
    "localFlags.subdivisions.us_sd.name": "South Dakota",
    "localFlags.subdivisions.us_tn.name": "Tennessee",
    "localFlags.subdivisions.us_tx.name": "Texas",
    "localFlags.subdivisions.us_ut.name": "Utah",
    "localFlags.subdivisions.us_vt.name": "Vermont",
    "localFlags.subdivisions.us_va.name": "Virginia",
    "localFlags.subdivisions.us_wa.name": "Washington",
    "localFlags.subdivisions.us_wv.name": "West Virginia",
    "localFlags.subdivisions.us_wi.name": "Wisconsin",
    "localFlags.subdivisions.us_wy.name": "Wyoming",
    "localFlags.subdivisions.gb_eng.name": "England",
    "localFlags.subdivisions.gb_sct.name": "Scotland",
    "localFlags.subdivisions.gb_wls.name": "Wales",
    "localFlags.subdivisions.gb_nir.name": "Northern Ireland",
    "localFlags.subdivisions.gb_iom.name": "Isle of Man",
    "localFlags.subdivisions.gb_jsy.name": "Jersey",
    "localFlags.subdivisions.gb_ggy.name": "Guernsey",
    "localFlags.subdivisions.gb_gib.name": "Gibraltar",
    "localFlags.subdivisions.gb_bmu.name": "Bermuda",
    "localFlags.subdivisions.gb_cym.name": "Cayman Islands",

    selectLevel: "Select level",
    totalStars: "Total",
    locked: "Locked",
    needMoreStars: "You need more stars to unlock this section.",
    back: "Back",
    coinsPillLabel: "Shop",
    storeExtraHeartLabel: "Extra Heart",
    storeRefillHeartsLabel: "Refill hearts to max",
    storeHeartsFull: "Full",

    spinForHintsTitle: "Daily Booster",
    youWon: "You won",
    spinOncePerDay: "Select a box once every 24 hours",
    claim: "Claim",

    profileSettings: "Profile & Settings",
    sound: "Sound",
    soundEffectsTitle: "Sound Effects",
    soundEffectsSubtitle: "Play audio feedback during gameplay",
    memberSince: "Member since",
    volume: "Volume",
    language: "Language",
    logout: "Log out",
    privacyPolicy: "Privacy Policy",
    termsAndConditions: "Terms & Conditions",
    areYouSure: "Are you sure?",
    close: "Close",
    footerTerms: "Terms",
    footerPrivacy: "Privacy",
    footerContact: "Contact",
    username: "Username",

    // Store / shop
    storeTitle: "Booster shop",
    storeSubtitle: "Spend coins on hints or get more coins.",
    storeYourCoins: "Your coins",
    storeBoostersTitle: "Spend coins on boosters",
    storeBoostersDesc: "Booster hints can be used in any mode.",
    storeCoinPacksTitle: "Get more coins",
    storeCoinPacksDesc:
      "Choose a pack to add coins.",

    storeBuyButton: "Buy",
    storePurchasedShort: "Purchased ✓",
    storeUnlockedShort: "Unlocked ✓",
    storeNotEnoughCoins: "Not enough coins for that.",
    storeBoughtBundle: "You bought 1 of each hint!",
    storeBoughtSingle: "Purchase successful!",
    storePurchaseFailedRetry: "Purchase failed. Please try again.",
    storePurchaseCancelled: "Purchase cancelled.",
    storeCoinsAdded: "Purchase successful! Coins added to your balance.",
    storeCoinsLabel: "coins",

    storeRemove2Single: "Remove 2 (x1)",
    storePauseSingle: "Pause timer (x1)",
    storeAutoPassSingle: "Auto pass (x1)",
    storeAllBundle: "Triple pack (1 of each)",

    login: "Log In",
    createAccount: "Create Account",
    playAsGuest: "Play as Guest",
    entryAccountBenefits: "Save your progress, keep your coins safe, and play across devices.",
    maybeLater: "Maybe Later",
    guestPromptTitle: "Keep your progress safe",
    guestPromptBody: "You completed {{milestone}} levels as a guest. Create an account to keep your progress, coins, and lives across devices.",
    restorePurchases: "Restore Purchases",
    restorePurchasesWorking: "Restoring purchases...",
    restorePurchasesSuccess: "Purchases restored successfully.",
    restorePurchasesFailed: "Could not restore purchases right now.",
    deleteAccount: "Delete Account",
    deleteAccountConfirmTitle: "Permanently delete account?",
    deleteAccountConfirmBody: "This action cannot be undone. Your account will be permanently deleted, and you will be signed out.",
    deleteAccountConfirmAction: "Yes, delete account",
    cancel: "Cancel",
    deleting: "Deleting...",
    level_complete_cta_button: "Create Account / Log In",
    level_complete_cta_text: "Save your progress or continue where you left off.",

    gameOver: "Game Over",
    tryAgain: "Try Again",
    levelComplete: "Level Complete",
    nextLevel: "Next Level",
    goToShop: "Go to Shop",
    goToMainMenu: "Go to Main Menu",
    timeTrialComplete: "Time Trial Complete",
    finalScore: "Final score",
    score: "Score",
    coins: "Coins",

    levelWord: "Level",

    coinsEarnedMessage: "You earned 100 coins!",

    "hint.title": "How hints work 💡",
    "hint.subtitle": "Use these to help answer tough flags:",
    "hints.removeTwo.label": "Remove 2",
    "hints.removeTwo.description": "Eliminates two incorrect answers.",
    "hints.autoPass.label": "Auto Pass",
    "hints.autoPass.description": "Selects the correct answer for you.",
    "hints.pauseTimer.label": "Pause",
    "hints.pauseTimer.description": "Pauses the timer for 3 seconds (Time Trial only).",
    "hints.bundleAll.label": "Triple pack (1 of each)",
    "hint.remove2Label": "Remove 2",
    "hint.remove2Desc": "Removes two wrong answers.",
    "hint.autoPassLabel": "Auto Pass",
    "hint.autoPassDesc": "Picks the correct flag for you.",
    "hint.pauseLabel": "Pause",
    "hint.pauseDesc": "Pauses the timer for 3 seconds (Time Trial only).",
    "hint.button": "Hints",
    "hint.info": "What do hints do?",
    "hint.notEnough": "Not enough hints.",
    ok: "Got it",
    loading: "Loading…",
    loadingChoices: "Loading choices…",

    dailySpin: "Daily Booster",
    readyToSpin: "Ready to spin",
    comeBackIn: "Come back in",
    spinForHints: "Booster Wheel",
    spinEveryDay: "Spin once every 24 hours",
    spinInfoTitle: "How it works",
    spinInfoBody:
      "Select a box once a day for free hint boosts.",
    spinToReveal: " ",
    spinNow: "Spin now",
    spinning: "Spinning…",

    "auth.welcome": "Welcome to FlagIQ",
    "auth.loginTab": "Login",
    "auth.signupTab": "Create account",

    "auth.emailOrUsername": "Email or Username",
    "auth.emailOrUsernamePlaceholder": "Enter your email or username",
    "auth.emailRequired": "Email address is required.",
    "auth.emailInvalid": "Please enter a valid email address.",

    "auth.password": "Password",
    "auth.passwordPlaceholder": "Enter your password",

    "auth.username": "Username",
    "auth.usernamePlaceholder": "Pick a username",
    "auth.usernameHint": "Minimum 6 characters.",

    "auth.email": "Email",
    "auth.emailPlaceholder": "Enter your email",

    "auth.show": "Show",
    "auth.hide": "Hide",
    "auth.forgot": "Forgot password?",
    "auth.keepSignedIn": "Keep me signed in",
    "auth.keepSignedInHelper": "Recommended on personal devices.",
    "auth.passwordHint":
      "At least 6 characters, 1 uppercase, 1 lowercase, 1 special.",

    "auth.passwordConfirm": "Confirm password",
"auth.resetTitle": "Reset your password",
"auth.resetIntro": "Choose a new password for your FlagIQ account.",
"auth.resetSubmit": "Save new password",
"auth.resetSuccess": "Your password has been updated. You can now return to the app and log in.",
"auth.resetMismatch": "Passwords do not match.",
"auth.passwordRequired": "Please enter your new password.",
"auth.loadingRecoveryLink": "Loading recovery link…",
"auth.resetError": "Could not update your password. The link may have expired.",
"auth.passwordReuseError": "You cannot use a previous password. Please choose a new password.",
    "auth.resetInvalid": "This reset link is invalid or has expired.",
    "auth.resetNeutral": "Please use the password reset link from your email.",
    "auth.passwordPlaceholder2": "Re-enter your new password",




    // errors
    "auth.missingCredentials": "Please enter your credentials.",
    "auth.userNotFound": "User not found.",
    "auth.invalidPassword": "Incorrect password.",
    "auth.usernameTooShort": "Username must be at least 6 characters.",
    "auth.usernameTaken": "That username is already taken.",
    "auth.emailInvalid": "Please enter a valid email address.",
    "auth.passwordTooShort": "Password must be at least 6 characters.",
    "auth.passwordNeedUpper":
      "Password must contain at least one uppercase letter.",
    "auth.passwordNeedLower":
      "Password must contain at least one lowercase letter.",
    "auth.passwordNeedSpecial":
      "Password must contain at least one special character.",

        "auth.resetInfo":
      "Enter your email and we’ll send you a link to reset your password.",
    "auth.resetEmailSent":
      "If an account exists for that email, you'll receive a reset link shortly.",
    "auth.resetError":
      "Could not send reset link. Please try again.",
    "auth.sendResetLink": "Send reset link",
    "auth.backToLogin": "Back to login",


    "flag.Afghanistan": "Afghanistan",
    "flag.Albania": "Albania",
    "flag.Algeria": "Algeria",
    "flag.American Samoa": "American Samoa",
    "flag.Andorra": "Andorra",
    "flag.Angola": "Angola",
    "flag.Anguilla": "Anguilla",
    "flag.Antarctica": "Antarctica",
    "flag.Antigua and Barbuda": "Antigua and Barbuda",
    "flag.Argentina": "Argentina",
    "flag.Armenia": "Armenia",
    "flag.Aruba": "Aruba",
    "flag.Australia": "Australia",
    "flag.Austria": "Austria",
    "flag.Azerbaijan": "Azerbaijan",
    "flag.Bahamas": "Bahamas",
    "flag.Bahrain": "Bahrain",
    "flag.Bangladesh": "Bangladesh",
    "flag.Barbados": "Barbados",
    "flag.Belarus": "Belarus",
    "flag.Belgium": "Belgium",
    "flag.Belize": "Belize",
    "flag.Benin": "Benin",
    "flag.Bermuda": "Bermuda",
    "flag.Bhutan": "Bhutan",
    "flag.Bolivia": "Bolivia",
    "flag.Bonaire": "Bonaire",
    "flag.Bosnia and Herzegovina": "Bosnia and Herzegovina",
    "flag.Botswana": "Botswana",
    "flag.Brazil": "Brazil",
    "flag.British Indian Ocean Territory": "British Indian Ocean Territory",
    "flag.British Virgin Islands": "British Virgin Islands",
    "flag.Brunei": "Brunei",
    "flag.Bulgaria": "Bulgaria",
    "flag.Burkina Faso": "Burkina Faso",
    "flag.Burundi": "Burundi",
    "flag.Cambodia": "Cambodia",
    "flag.Cameroon": "Cameroon",
    "flag.Canada": "Canada",
    "flag.Cape Verde": "Cape Verde",
    "flag.Cayman Islands": "Cayman Islands",
    "flag.Central African Republic": "Central African Republic",
    "flag.Chad": "Chad",
    "flag.Chile": "Chile",
    "flag.China": "China",
    "flag.Christmas Island": "Christmas Island",
    "flag.Cocos (Keeling) Islands": "Cocos (Keeling) Islands",
    "flag.Colombia": "Colombia",
    "flag.Comoros": "Comoros",
    "flag.Congo (DRC)": "Congo (DRC)",
    "flag.Congo (Republic)": "Congo (Republic)",
    "flag.Cook Islands": "Cook Islands",
    "flag.Costa Rica": "Costa Rica",
    "flag.Croatia": "Croatia",
    "flag.Cuba": "Cuba",
    "flag.Curaçao": "Curaçao",
    "flag.Cyprus": "Cyprus",
    "flag.Czech Republic": "Czechia",
    "flag.Denmark": "Denmark",
    "flag.Djibouti": "Djibouti",
    "flag.Dominica": "Dominica",
    "flag.Dominican Republic": "Dominican Republic",
    "flag.Ecuador": "Ecuador",
    "flag.Egypt": "Egypt",
    "flag.El Salvador": "El Salvador",
    "flag.England": "England",
    "flag.Equatorial Guinea": "Equatorial Guinea",
    "flag.Eritrea": "Eritrea",
    "flag.Estonia": "Estonia",
    "flag.Eswatini": "Eswatini",
    "flag.Ethiopia": "Ethiopia",
    "flag.Falkland Islands": "Falkland Islands",
    "flag.Faroe Islands": "Faroe Islands",
    "flag.Fiji": "Fiji",
    "flag.Finland": "Finland",
    "flag.France": "France",
    "flag.French Guiana": "French Guiana",
    "flag.French Polynesia": "French Polynesia",
    "flag.Gabon": "Gabon",
    "flag.Gambia": "Gambia",
    "flag.Georgia": "Georgia",
    "flag.Germany": "Germany",
    "flag.Ghana": "Ghana",
    "flag.Gibraltar": "Gibraltar",
    "flag.Greece": "Greece",
    "flag.Greenland": "Greenland",
    "flag.Grenada": "Grenada",
    "flag.Guadeloupe": "Guadeloupe",
    "flag.Guatemala": "Guatemala",
    "flag.Guernsey": "Guernsey",
    "flag.Guinea": "Guinea",
    "flag.Guinea-Bissau": "Guinea-Bissau",
    "flag.Guyana": "Guyana",
    "flag.Haiti": "Haiti",
    "flag.Honduras": "Honduras",
    "flag.Hong Kong": "Hong Kong",
    "flag.Hungary": "Hungary",
    "flag.Iceland": "Iceland",
    "flag.India": "India",
    "flag.Indonesia": "Indonesia",
    "flag.Iran": "Iran",
    "flag.Iraq": "Iraq",
    "flag.Ireland": "Ireland",
    "flag.Isle of Man": "Isle of Man",
    "flag.Israel": "Israel",
    "flag.Italy": "Italy",
    "flag.Ivory Coast": "Ivory Coast",
    "flag.Jamaica": "Jamaica",
    "flag.Japan": "Japan",
    "flag.Jersey": "Jersey",
    "flag.Jordan": "Jordan",
    "flag.Kazakhstan": "Kazakhstan",
    "flag.Kenya": "Kenya",
    "flag.Kiribati": "Kiribati",
    "flag.Kosovo": "Kosovo",
    "flag.Kuwait": "Kuwait",
    "flag.Kyrgyzstan": "Kyrgyzstan",
    "flag.Laos": "Laos",
    "flag.Latvia": "Latvia",
    "flag.Lebanon": "Lebanon",
    "flag.Lesotho": "Lesotho",
    "flag.Liberia": "Liberia",
    "flag.Libya": "Libya",
    "flag.Liechtenstein": "Liechtenstein",
    "flag.Lithuania": "Lithuania",
    "flag.Luxembourg": "Luxembourg",
    "flag.Macau": "Macau",
    "flag.Madagascar": "Madagascar",
    "flag.Malawi": "Malawi",
    "flag.Malaysia": "Malaysia",
    "flag.Maldives": "Maldives",
    "flag.Mali": "Mali",
    "flag.Malta": "Malta",
    "flag.Marshall Islands": "Marshall Islands",
    "flag.Martinique": "Martinique",
    "flag.Mauritania": "Mauritania",
    "flag.Mauritius": "Mauritius",
    "flag.Mayotte": "Mayotte",
    "flag.Mexico": "Mexico",
    "flag.Micronesia": "Micronesia",
    "flag.Moldova": "Moldova",
    "flag.Monaco": "Monaco",
    "flag.Mongolia": "Mongolia",
    "flag.Montenegro": "Montenegro",
    "flag.Montserrat": "Montserrat",
    "flag.Morocco": "Morocco",
    "flag.Mozambique": "Mozambique",
    "flag.Myanmar": "Myanmar",
    "flag.Namibia": "Namibia",
    "flag.Nauru": "Nauru",
    "flag.Nepal": "Nepal",
    "flag.Netherlands": "Netherlands",
    "flag.New Caledonia": "New Caledonia",
    "flag.New Zealand": "New Zealand",
    "flag.Nicaragua": "Nicaragua",
    "flag.Niger": "Niger",
    "flag.Nigeria": "Nigeria",
    "flag.Niue": "Niue",
    "flag.Norfolk Island": "Norfolk Island",
    "flag.North Korea": "North Korea",
    "flag.North Macedonia": "North Macedonia",
    "flag.Northern Ireland": "Northern Ireland",
    "flag.Northern Mariana Islands": "Northern Mariana Islands",
    "flag.Norway": "Norway",
    "flag.Oman": "Oman",
    "flag.Pakistan": "Pakistan",
    "flag.Palau": "Palau",
    "flag.Palestine": "Palestine",
    "flag.Panama": "Panama",
    "flag.Papua New Guinea": "Papua New Guinea",
    "flag.Paraguay": "Paraguay",
    "flag.Peru": "Peru",
    "flag.Philippines": "Philippines",
    "flag.Pitcairn Islands": "Pitcairn Islands",
    "flag.Poland": "Poland",
    "flag.Portugal": "Portugal",
    "flag.Puerto Rico": "Puerto Rico",
    "flag.Qatar": "Qatar",
    "flag.Reunion": "Reunion",
    "flag.Romania": "Romania",
    "flag.Russia": "Russia",
    "flag.Rwanda": "Rwanda",
    "flag.Saint Barthélemy": "Saint Barthélemy",
    "flag.Saint Helena": "Saint Helena",
    "flag.Saint Kitts and Nevis": "Saint Kitts and Nevis",
    "flag.Saint Lucia": "Saint Lucia",
    "flag.Saint Martin": "Saint Martin",
    "flag.Saint Pierre and Miquelon": "Saint Pierre and Miquelon",
    "flag.Saint Vincent and the Grenadines": "Saint Vincent and the Grenadines",
    "flag.Samoa": "Samoa",
    "flag.San Marino": "San Marino",
    "flag.Sao Tome and Principe": "Sao Tome and Principe",
    "flag.Saudi Arabia": "Saudi Arabia",
    "flag.Scotland": "Scotland",
    "flag.Senegal": "Senegal",
    "flag.Serbia": "Serbia",
    "flag.Seychelles": "Seychelles",
    "flag.Sierra Leone": "Sierra Leone",
    "flag.Singapore": "Singapore",
    "flag.Sint Maarten": "Sint Maarten",
    "flag.Slovakia": "Slovakia",
    "flag.Slovenia": "Slovenia",
    "flag.Solomon Islands": "Solomon Islands",
    "flag.Somalia": "Somalia",
    "flag.South Africa": "South Africa",
    "flag.South Korea": "South Korea",
    "flag.South Sudan": "South Sudan",
    "flag.Spain": "Spain",
    "flag.Sri Lanka": "Sri Lanka",
    "flag.Sudan": "Sudan",
    "flag.Suriname": "Suriname",
    "flag.Sweden": "Sweden",
    "flag.Switzerland": "Switzerland",
    "flag.Syria": "Syria",
    "flag.Taiwan": "Taiwan",
    "flag.Tajikistan": "Tajikistan",
    "flag.Tanzania": "Tanzania",
    "flag.Thailand": "Thailand",
    "flag.Timor-Leste": "Timor-Leste",
    "flag.Togo": "Togo",
    "flag.Tokelau": "Tokelau",
    "flag.Tonga": "Tonga",
    "flag.Trinidad and Tobago": "Trinidad and Tobago",
    "flag.Tunisia": "Tunisia",
    "flag.Turkey": "Turkey",
    "flag.Turkmenistan": "Turkmenistan",
    "flag.Turks and Caicos Islands": "Turks and Caicos Islands",
    "flag.Tuvalu": "Tuvalu",
    "flag.Uganda": "Uganda",
    "flag.Ukraine": "Ukraine",
    "flag.United Arab Emirates": "United Arab Emirates",
    "flag.United Kingdom": "United Kingdom",
    "flag.United States": "United States",
    "flag.Uruguay": "Uruguay",
    "flag.Uzbekistan": "Uzbekistan",
    "flag.Vanuatu": "Vanuatu",
    "flag.Vatican City": "Vatican City",
    "flag.Venezuela": "Venezuela",
    "flag.Vietnam": "Vietnam",
    "flag.Wales": "Wales",
    "flag.Wallis and Futuna": "Wallis and Futuna",
    "flag.Western Sahara": "Western Sahara",
    "flag.Yemen": "Yemen",
    "flag.Zambia": "Zambia",
    "flag.Zimbabwe": "Zimbabwe",
    "flag.Guam": "Guam",
    "flag.U.S. Virgin Islands": "U.S. Virgin Islands",
    "flag.South Georgia and South Sandwich Islands":
      "South Georgia and South Sandwich Islands",
    "flag.Curacao": "Curaçao",
    "flag.Ascension Island": "Ascension Island",
  },

  es: {
    appTitle: "FlagIQ",
    appSubtitle:
      "Pon a prueba tu conocimiento del mundo — una bandera a la vez",
    homeInfoTitle: "Cómo jugar",
    homeInfoBody:
      "🎯 Objetivo: Identifica el país correcto para cada bandera. Cuanto más rápido y preciso seas, mejor será tu puntuación.\n\n🎮 Modos de juego:\n• Modo Clásico: juega a tu ritmo sin presión de tiempo.\n• Contrarreloj: compite contra el reloj donde la velocidad y la precisión importan; las respuestas correctas más rápidas dan mayor puntuación.\n• Banderas locales: explora packs regionales como estados de EE. UU. y domina banderas locales.\n\n❤️ Sistema de vidas: Pierdes una vida cada vez que no completas un nivel con éxito. Las vidas se recargan automáticamente con el tiempo.\n\n💡 Pistas y potenciadores:\n• Quitar 2: elimina dos opciones incorrectas.\n• Pase automático: completa la bandera al instante y te hace avanzar.\n• Pausar temporizador: congela el reloj de Contrarreloj durante 3 segundos.\n\n⭐ Estrellas y progreso: Gana hasta tres estrellas por nivel según tu rendimiento. Reúne estrellas para desbloquear nuevos niveles, regiones y packs especiales de banderas.\n\n🪙 Monedas y recompensas: Completar un nivel por primera vez otorga monedas. Gástalas en la tienda en pistas y potenciadores para avanzar más rápido.\n\n🎁 Potenciador diario: Abre una caja gratis cada 24 horas para recibir pistas y potenciadores.",
    homeLeaderboardTitle: "Clasificación",
    homeLeaderboardBody:
      "La clasificación global está en camino. Pronto habrá rankings competitivos.",
    leaderboardTopLabel: "Top 100 jugadores • Puntos totales",
    leaderboardLoading: "Cargando clasificación...",
    leaderboardError: "No se puede cargar la clasificación ahora.",
    leaderboardEmpty: "Aún no hay puntuaciones de Contrarreloj.",
    leaderboardLoginRequired:
      "La clasificación está disponible solo para usuarios con sesión iniciada.",
    "homeInfo.goal.title": "Objetivo",
    "homeInfo.goal.body": "Identifica el país correcto para cada bandera. Cuanto más rápido y preciso seas, mejor será tu puntuación.",
    "homeInfo.modes.title": "Modos de juego",
    "homeInfo.modes.classic": "Modo clásico: juega a tu ritmo sin presión de tiempo.",
    "homeInfo.modes.timetrial": "Contrarreloj: compite contra el reloj; la velocidad y la precisión importan.",
    "homeInfo.modes.local": "Banderas locales: explora paquetes regionales como estados de EE. UU. y domina sus banderas.",
    "homeInfo.lives.title": "Sistema de vidas",
    "homeInfo.lives.body": "Pierdes una vida cada vez que no logras completar un nivel. Las vidas se recargan automáticamente con el tiempo.",
    "homeInfo.hints.title": "Pistas y potenciadores",
    "homeInfo.hints.remove2.label": "Eliminar 2",
    "homeInfo.hints.remove2.body": "Elimina dos opciones incorrectas.",
    "homeInfo.hints.autopass.label": "Pase automático",
    "homeInfo.hints.autopass.body": "Completa instantáneamente la bandera y te hace avanzar.",
    "homeInfo.hints.pause.label": "Pausar temporizador",
    "homeInfo.hints.pause.body": "Congela el reloj de Contrarreloj durante 3 segundos.",
    "homeInfo.stars.title": "Estrellas y progreso",
    "homeInfo.stars.body": "Gana hasta tres estrellas por nivel según tu rendimiento. Reúne estrellas para desbloquear nuevos niveles, regiones y paquetes especiales.",
    "homeInfo.coins.title": "Monedas y recompensas",
    "homeInfo.coins.body": "Completar un nivel por primera vez te da monedas. Úsalas en la tienda para avanzar más rápido.",
    "homeInfo.daily.title": "Potenciador diario",
    "homeInfo.daily.body": "Abre una caja de potenciador gratis cada 24 horas para recibir ayudas y mejoras.",
    "leaderboard.attempts.one": "{{count}} intento",
    "leaderboard.attempts.other": "{{count}} intentos",

    classic: "Clásico",
    classicDesc: "Aprende banderas a tu ritmo",
    timeTrial: "Contrarreloj",
    timeTrialDesc: "¡Vence al tiempo!",
    comingSoon: "Próximamente",
    localFlags: "Banderas locales",
    localFlagsDesc: "Solo para jugadores expertos",
    "localFlags.packType.all": "Paquete total",
    "localFlags.packType.country": "Paquete de país",
    "localFlags.packs.all.name": "Todas las banderas locales",
    "localFlags.packs.all.short": "Todas",
    "localFlags.packs.ch.name": "Suiza",
    "localFlags.packs.de.name": "Alemania",
    "localFlags.packs.es.name": "España",
    "localFlags.packs.gb.name": "Reino Unido",
    "localFlags.packs.us.name": "Estados Unidos",

    selectLevel: "Selecciona nivel",
    totalStars: "Total",
    locked: "Bloqueado",
    needMoreStars: "Necesitas más estrellas para desbloquear esta sección.",
    back: "Volver",
    coinsPillLabel: "Tienda",
    storeExtraHeartLabel: "Corazón extra",
    storeRefillHeartsLabel: "Rellenar corazones al máximo",
    storeHeartsFull: "Lleno",

    spinForHintsTitle: "Potenciador diario",
    youWon: "Has ganado",
    spinOncePerDay: "Elige una caja una vez cada 24 horas",
    claim: "Reclamar",

    storeTitle: "Tienda de potenciadores",
    storeSubtitle: "Gasta tus monedas en pistas o consigue más monedas.",
    storeYourCoins: "Tus monedas",

    storeBoostersTitle: "Potenciadores por monedas",
    storeBoostersDesc: "Las pistas especiales pueden usarse en cualquier modo.",

    storeCoinPacksTitle: "Consigue más monedas",
    storeCoinPacksDesc:
      "Elige un paquete para añadir monedas.",

    storeBuyButton: "Comprar",
    storeNotEnoughCoins: "No tienes suficientes monedas.",
    storeBoughtBundle: "¡Has comprado 1 de cada pista!",
    storeBoughtSingle: "¡Compra realizada!",
    storePurchaseCancelled: "Compra cancelada.",
    storeCoinsAdded: "¡Compra realizada! Monedas añadidas a tu saldo.",
    storeCoinsLabel: "monedas",

    storeRemove2Single: "Eliminar 2 (x1)",
    storePauseSingle: "Pausar temporizador (x1)",
    storeAutoPassSingle: "Auto-pasar (x1)",
    storeAllBundle: "Pack triple (1 de cada)",

    profileSettings: "Perfil y ajustes",
    sound: "Sonido",
    soundEffectsTitle: "Efectos de sonido",
    soundEffectsSubtitle: "Reproducir audio durante la partida",
    memberSince: "Miembro desde",
    volume: "Volumen",
    language: "Idioma",
    logout: "Cerrar sesión",
    privacyPolicy: "Política de privacidad",
    termsAndConditions: "Términos y condiciones",
    areYouSure: "¿Estás seguro?",
    close: "Cerrar",
    footerTerms: "Términos",
    footerPrivacy: "Privacidad",
    footerContact: "Contacto",
    username: "Nombre de usuario",

    login: "Iniciar sesión",
    createAccount: "Crear cuenta",
    playAsGuest: "Jugar como invitado",
    entryAccountBenefits: "Guarda tu progreso, protege tus monedas y juega en varios dispositivos.",
    maybeLater: "Quizás más tarde",
    guestPromptTitle: "Protege tu progreso",
    guestPromptBody: "Has completado {{milestone}} niveles como invitado. Crea una cuenta para guardar progreso, monedas y vidas en todos tus dispositivos.",
    restorePurchases: "Restaurar compras",
    restorePurchasesWorking: "Restaurando compras...",
    restorePurchasesSuccess: "Compras restauradas correctamente.",
    restorePurchasesFailed: "No se pudieron restaurar las compras ahora.",
    deleteAccount: "Eliminar cuenta",
    deleteAccountConfirmTitle: "¿Eliminar la cuenta permanentemente?",
    deleteAccountConfirmBody: "Esta acción no se puede deshacer. Tu cuenta se eliminará permanentemente y se cerrará tu sesión.",
    deleteAccountConfirmAction: "Sí, eliminar cuenta",
    cancel: "Cancelar",
    deleting: "Eliminando...",
    level_complete_cta_button: "Crear cuenta / Iniciar sesión",
    level_complete_cta_text: "Guarda tu progreso o continúa donde lo dejaste.",

    levelWord: "Nivel",
    coins: "Monedas",
    coinsEarnedMessage: "¡Has ganado 100 monedas!",

    gameOver: "Has perdido",
    tryAgain: "Intentar de nuevo",
    levelComplete: "Nivel completado",
    nextLevel: "Siguiente nivel",
    goToShop: "Ir a la tienda",
    goToMainMenu: "Ir al menú principal",
    timeTrialComplete: "Tiempo límite completado",
    finalScore: "Puntuación final",
    score: "Puntuación",

    "hint.title": "Cómo funcionan las pistas 💡",
    "hint.subtitle": "Úsalas para ayudarte con las banderas difíciles:",
    "hints.removeTwo.label": "Eliminar 2",
    "hints.removeTwo.description": "Elimina dos respuestas incorrectas.",
    "hints.autoPass.label": "Pase automático",
    "hints.autoPass.description": "Elige la respuesta correcta por ti.",
    "hints.pauseTimer.label": "Pausar",
    "hints.pauseTimer.description": "Pausa el tiempo durante 3 segundos (solo Contrarreloj).",
    "hints.bundleAll.label": "Pack triple (1 de cada)",
    "hint.remove2Label": "Eliminar 2",
    "hint.remove2Desc": "Elimina dos respuestas incorrectas.",
    "hint.autoPassLabel": "Pase automático",
    "hint.autoPassDesc": "Elige la respuesta correcta por ti.",
    "hint.pauseLabel": "Pausar",
    "hint.pauseDesc": "Pausa el tiempo durante 3 segundos (solo Contrarreloj).",
    "hint.button": "Pistas",
    "hint.info": "¿Qué hacen las pistas?",
    "hint.notEnough": "No tienes suficientes pistas.",
    ok: "Entendido",
    loading: "Cargando…",
    loadingChoices: "Cargando opciones…",

    dailySpin: "Potenciador diario",
    readyToSpin: "Listo para girar",
    comeBackIn: "Vuelve en",
    spinForHints: "Rueda de potenciadores",
    spinEveryDay: "Gira una vez cada 24 horas",
    spinInfoTitle: "Cómo funciona",
    spinInfoBody:
      "Elige una caja una vez al día para conseguir potenciadores de pista gratis.",
    spinToReveal: " ",
    spinNow: "Girar ahora",
    spinning: "Girando…",

    "auth.welcome": "Bienvenido a FlagIQ",
    "auth.loginTab": "Iniciar sesión",
    "auth.signupTab": "Crear cuenta",

    "auth.emailOrUsername": "Correo electrónico o nombre de usuario",
    "auth.emailOrUsernamePlaceholder":
      "Introduce tu correo electrónico o nombre de usuario",

    "auth.password": "Contraseña",
    "auth.passwordPlaceholder": "Introduce tu contraseña",

    "auth.username": "Nombre de usuario",
    "auth.usernamePlaceholder": "Elige un nombre de usuario",
    "auth.usernameHint": "Mínimo 6 caracteres.",

    "auth.email": "Correo electrónico",
    "auth.emailPlaceholder": "Introduce tu correo electrónico",
    "auth.emailRequired": "Se requiere una dirección de correo electrónico.",
    "auth.emailInvalid": "Por favor, introduce una dirección de correo válida.",

    "auth.show": "Mostrar",
    "auth.hide": "Ocultar",
    "auth.forgot": "¿Olvidaste tu contraseña?",
    "auth.keepSignedIn": "Mantener la sesión iniciada",
    "auth.keepSignedInHelper": "Recomendado en dispositivos personales.",
    "auth.passwordHint":
      "Al menos 6 caracteres, 1 mayúscula, 1 minúscula y 1 carácter especial.",

    "auth.passwordConfirm": "Confirmar contraseña",
"auth.resetTitle": "Restablecer tu contraseña",
"auth.resetIntro": "Elige una nueva contraseña para tu cuenta de FlagIQ.",
"auth.resetSubmit": "Guardar nueva contraseña",
"auth.resetSuccess": "Tu contraseña se ha actualizado. Ahora puedes volver a la app e iniciar sesión.",
"auth.resetMismatch": "Las contraseñas no coinciden.",
"auth.passwordRequired": "Introduce tu nueva contraseña.",
"auth.loadingRecoveryLink": "Cargando enlace de recuperación…",
"auth.resetError": "No se pudo actualizar tu contraseña. Es posible que el enlace haya caducado.",
"auth.passwordReuseError": "No puedes usar una contraseña anterior. Elige una contraseña nueva.",
    "auth.resetInvalid": "Este enlace de restablecimiento no es válido o ha caducado.",
    "auth.resetNeutral": "Usa el enlace para restablecer la contraseña que recibiste por correo.",
    "auth.passwordPlaceholder2": "Vuelve a introducir tu nueva contraseña",



    // errores
    "auth.missingCredentials": "Por favor, introduce tus credenciales.",
    "auth.userNotFound": "Usuario no encontrado.",
    "auth.invalidPassword": "Contraseña incorrecta.",
    "auth.usernameTooShort":
      "El nombre de usuario debe tener al menos 6 caracteres.",
    "auth.usernameTaken": "Ese nombre de usuario ya está en uso.",
    "auth.emailInvalid": "Por favor, introduce una dirección de correo válida.",
    "auth.passwordTooShort": "La contraseña debe tener al menos 6 caracteres.",
    "auth.passwordNeedUpper":
      "La contraseña debe contener al menos una letra mayúscula.",
    "auth.passwordNeedLower":
      "La contraseña debe contener al menos una letra minúscula.",
    "auth.passwordNeedSpecial":
      "La contraseña debe contener al menos un carácter especial.",

        "auth.resetInfo":
      "Introduce tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.",
    "auth.resetEmailSent":
      "Si existe una cuenta con ese correo, recibirás en breve un enlace para restablecer la contraseña.",
    "auth.resetError":
      "No se pudo enviar el enlace de restablecimiento. Inténtalo de nuevo.",
    "auth.sendResetLink": "Enviar enlace de restablecimiento",
    "auth.backToLogin": "Volver a iniciar sesión",


    "flag.Afghanistan": "Afganistán",
    "flag.Albania": "Albania",
    "flag.Algeria": "Argelia",
    "flag.American Samoa": "Samoa Americana",
    "flag.Andorra": "Andorra",
    "flag.Angola": "Angola",
    "flag.Anguilla": "Anguila",
    "flag.Antarctica": "Antártida",
    "flag.Antigua and Barbuda": "Antigua y Barbuda",
    "flag.Argentina": "Argentina",
    "flag.Armenia": "Armenia",
    "flag.Aruba": "Aruba",
    "flag.Australia": "Australia",
    "flag.Austria": "Austria",
    "flag.Azerbaijan": "Azerbaiyán",
    "flag.Bahamas": "Bahamas",
    "flag.Bahrain": "Baréin",
    "flag.Bangladesh": "Bangladés",
    "flag.Barbados": "Barbados",
    "flag.Belarus": "Bielorrusia",
    "flag.Belgium": "Bélgica",
    "flag.Belize": "Belice",
    "flag.Benin": "Benín",
    "flag.Bermuda": "Bermudas",
    "flag.Bhutan": "Bután",
    "flag.Bolivia": "Bolivia",
    "flag.Bonaire": "Bonaire",
    "flag.Bosnia and Herzegovina": "Bosnia y Herzegovina",
    "flag.Botswana": "Botsuana",
    "flag.Brazil": "Brasil",
    "flag.British Indian Ocean Territory":
      "Territorio Británico del Océano Índico",
    "flag.British Virgin Islands": "Islas Vírgenes Británicas",
    "flag.Brunei": "Brunéi",
    "flag.Bulgaria": "Bulgaria",
    "flag.Burkina Faso": "Burkina Faso",
    "flag.Burundi": "Burundi",
    "flag.Cambodia": "Camboya",
    "flag.Cameroon": "Camerún",
    "flag.Canada": "Canadá",
    "flag.Cape Verde": "Cabo Verde",
    "flag.Cayman Islands": "Islas Caimán",
    "flag.Central African Republic": "República Centroafricana",
    "flag.Chad": "Chad",
    "flag.Chile": "Chile",
    "flag.China": "China",
    "flag.Christmas Island": "Isla de Navidad",
    "flag.Cocos (Keeling) Islands": "Islas Cocos",
    "flag.Colombia": "Colombia",
    "flag.Comoros": "Comoras",
    "flag.Congo (DRC)": "República Democrática del Congo",
    "flag.Congo (Republic)": "República del Congo",
    "flag.Cook Islands": "Islas Cook",
    "flag.Costa Rica": "Costa Rica",
    "flag.Croatia": "Croacia",
    "flag.Cuba": "Cuba",
    "flag.Curaçao": "Curazao",
    "flag.Cyprus": "Chipre",
    "flag.Czech Republic": "Chequia",
    "flag.Denmark": "Dinamarca",
    "flag.Djibouti": "Yibuti",
    "flag.Dominica": "Dominica",
    "flag.Dominican Republic": "República Dominicana",
    "flag.Ecuador": "Ecuador",
    "flag.Egypt": "Egipto",
    "flag.El Salvador": "El Salvador",
    "flag.England": "Inglaterra",
    "flag.Equatorial Guinea": "Guinea Ecuatorial",
    "flag.Eritrea": "Eritrea",
    "flag.Estonia": "Estonia",
    "flag.Eswatini": "Esuatini",
    "flag.Ethiopia": "Etiopía",
    "flag.Falkland Islands": "Islas Malvinas",
    "flag.Faroe Islands": "Islas Feroe",
    "flag.Fiji": "Fiyi",
    "flag.Finland": "Finlandia",
    "flag.France": "Francia",
    "flag.French Guiana": "Guayana Francesa",
    "flag.French Polynesia": "Polinesia Francesa",
    "flag.Gabon": "Gabón",
    "flag.Gambia": "Gambia",
    "flag.Georgia": "Georgia",
    "flag.Germany": "Alemania",
    "flag.Ghana": "Ghana",
    "flag.Gibraltar": "Gibraltar",
    "flag.Greece": "Grecia",
    "flag.Greenland": "Groenlandia",
    "flag.Grenada": "Granada",
    "flag.Guadeloupe": "Guadalupe",
    "flag.Guatemala": "Guatemala",
    "flag.Guernsey": "Guernsey",
    "flag.Guinea": "Guinea",
    "flag.Guinea-Bissau": "Guinea-Bisáu",
    "flag.Guyana": "Guyana",
    "flag.Haiti": "Haití",
    "flag.Honduras": "Honduras",
    "flag.Hong Kong": "Hong Kong",
    "flag.Hungary": "Hungría",
    "flag.Iceland": "Islandia",
    "flag.India": "India",
    "flag.Indonesia": "Indonesia",
    "flag.Iran": "Irán",
    "flag.Iraq": "Irak",
    "flag.Ireland": "Irlanda",
    "flag.Isle of Man": "Isla de Man",
    "flag.Israel": "Israel",
    "flag.Italy": "Italia",
    "flag.Ivory Coast": "Costa de Marfil",
    "flag.Jamaica": "Jamaica",
    "flag.Japan": "Japón",
    "flag.Jersey": "Jersey",
    "flag.Jordan": "Jordania",
    "flag.Kazakhstan": "Kazajistán",
    "flag.Kenya": "Kenia",
    "flag.Kiribati": "Kiribati",
    "flag.Kosovo": "Kosovo",
    "flag.Kuwait": "Kuwait",
    "flag.Kyrgyzstan": "Kirguistán",
    "flag.Laos": "Laos",
    "flag.Latvia": "Letonia",
    "flag.Lebanon": "Líbano",
    "flag.Lesotho": "Lesoto",
    "flag.Liberia": "Liberia",
    "flag.Libya": "Libia",
    "flag.Liechtenstein": "Liechtenstein",
    "flag.Lithuania": "Lituania",
    "flag.Luxembourg": "Luxemburgo",
    "flag.Macau": "Macao",
    "flag.Madagascar": "Madagascar",
    "flag.Malawi": "Malaui",
    "flag.Malaysia": "Malasia",
    "flag.Maldives": "Maldivas",
    "flag.Mali": "Malí",
    "flag.Malta": "Malta",
    "flag.Marshall Islands": "Islas Marshall",
    "flag.Martinique": "Martinica",
    "flag.Mauritania": "Mauritania",
    "flag.Mauritius": "Mauricio",
    "flag.Mayotte": "Mayotte",
    "flag.Mexico": "México",
    "flag.Micronesia": "Micronesia",
    "flag.Moldova": "Moldavia",
    "flag.Monaco": "Mónaco",
    "flag.Mongolia": "Mongolia",
    "flag.Montenegro": "Montenegro",
    "flag.Montserrat": "Montserrat",
    "flag.Morocco": "Marruecos",
    "flag.Mozambique": "Mozambique",
    "flag.Myanmar": "Myanmar",
    "flag.Namibia": "Namibia",
    "flag.Nauru": "Nauru",
    "flag.Nepal": "Nepal",
    "flag.Netherlands": "Países Bajos",
    "flag.New Caledonia": "Nueva Caledonia",
    "flag.New Zealand": "Nueva Zelanda",
    "flag.Nicaragua": "Nicaragua",
    "flag.Niger": "Níger",
    "flag.Nigeria": "Nigeria",
    "flag.Niue": "Niue",
    "flag.Norfolk Island": "Isla Norfolk",
    "flag.North Korea": "Corea del Norte",
    "flag.North Macedonia": "Macedonia del Norte",
    "flag.Northern Ireland": "Irlanda del Norte",
    "flag.Northern Mariana Islands": "Islas Marianas del Norte",
    "flag.Norway": "Noruega",
    "flag.Oman": "Omán",
    "flag.Pakistan": "Pakistán",
    "flag.Palau": "Palaos",
    "flag.Palestine": "Palestina",
    "flag.Panama": "Panamá",
    "flag.Papua New Guinea": "Papúa Nueva Guinea",
    "flag.Paraguay": "Paraguay",
    "flag.Peru": "Perú",
    "flag.Philippines": "Filipinas",
    "flag.Pitcairn Islands": "Islas Pitcairn",
    "flag.Poland": "Polonia",
    "flag.Portugal": "Portugal",
    "flag.Puerto Rico": "Puerto Rico",
    "flag.Qatar": "Catar",
    "flag.Reunion": "Reunión",
    "flag.Romania": "Rumanía",
    "flag.Russia": "Rusia",
    "flag.Rwanda": "Ruanda",
    "flag.Saint Barthélemy": "San Bartolomé",
    "flag.Saint Helena": "Santa Elena",
    "flag.Saint Kitts and Nevis": "San Cristóbal y Nieves",
    "flag.Saint Lucia": "Santa Lucía",
    "flag.Saint Martin": "San Martín",
    "flag.Saint Pierre and Miquelon": "San Pedro y Miquelón",
    "flag.Saint Vincent and the Grenadines": "San Vicente y las Granadinas",
    "flag.Samoa": "Samoa",
    "flag.San Marino": "San Marino",
    "flag.Sao Tome and Principe": "Santo Tomé y Príncipe",
    "flag.Saudi Arabia": "Arabia Saudita",
    "flag.Scotland": "Escocia",
    "flag.Senegal": "Senegal",
    "flag.Serbia": "Serbia",
    "flag.Seychelles": "Seychelles",
    "flag.Sierra Leone": "Sierra Leona",
    "flag.Singapore": "Singapur",
    "flag.Sint Maarten": "Sint Maarten",
    "flag.Slovakia": "Eslovaquia",
    "flag.Slovenia": "Eslovenia",
    "flag.Solomon Islands": "Islas Salomón",
    "flag.Somalia": "Somalia",
    "flag.South Africa": "Sudáfrica",
    "flag.South Korea": "Corea del Sur",
    "flag.South Sudan": "Sudán del Sur",
    "flag.Spain": "España",
    "flag.Sri Lanka": "Sri Lanka",
    "flag.Sudan": "Sudán",
    "flag.Suriname": "Surinam",
    "flag.Sweden": "Suecia",
    "flag.Switzerland": "Suiza",
    "flag.Syria": "Siria",
    "flag.Taiwan": "Taiwán",
    "flag.Tajikistan": "Tayikistán",
    "flag.Tanzania": "Tanzania",
    "flag.Thailand": "Tailandia",
    "flag.Timor-Leste": "Timor Oriental",
    "flag.Togo": "Togo",
    "flag.Tokelau": "Tokelau",
    "flag.Tonga": "Tonga",
    "flag.Trinidad and Tobago": "Trinidad y Tobago",
    "flag.Tunisia": "Túnez",
    "flag.Turkey": "Turquía",
    "flag.Turkmenistan": "Turkmenistán",
    "flag.Turks and Caicos Islands": "Islas Turcas y Caicos",
    "flag.Tuvalu": "Tuvalu",
    "flag.Uganda": "Uganda",
    "flag.Ukraine": "Ucrania",
    "flag.United Arab Emirates": "Emiratos Árabes Unidos",
    "flag.United Kingdom": "Reino Unido",
    "flag.United States": "Estados Unidos",
    "flag.Uruguay": "Uruguay",
    "flag.Uzbekistan": "Uzbekistán",
    "flag.Vanuatu": "Vanuatu",
    "flag.Vatican City": "Ciudad del Vaticano",
    "flag.Venezuela": "Venezuela",
    "flag.Vietnam": "Vietnam",
    "flag.Wales": "Gales",
    "flag.Wallis and Futuna": "Wallis y Futuna",
    "flag.Western Sahara": "Sahara Occidental",
    "flag.Yemen": "Yemen",
    "flag.Zambia": "Zambia",
    "flag.Zimbabwe": "Zimbabue",
    "flag.Guam": "Guam",
    "flag.U.S. Virgin Islands": "Islas Vírgenes de los Estados Unidos",
    "flag.South Georgia and South Sandwich Islands":
      "Georgia del Sur e Islas Sandwich del Sur",
    "flag.Curacao": "Curazao",
    "flag.Ascension Island": "Isla de la Ascensión",
  },

  pt: {
    appTitle: "FlagIQ",
    appSubtitle: "Teste o seu conhecimento do mundo — uma bandeira de cada vez",
    homeInfoTitle: "Como jogar",
    homeInfoBody:
      "🎯 Objetivo: Identifique o país correto de cada bandeira. Quanto mais rápido e preciso for, melhor será a sua pontuação.\n\n🎮 Modos de jogo:\n• Modo Clássico: jogue no seu ritmo sem pressão de tempo.\n• Contra o tempo: corra contra o relógio, onde a velocidade e a precisão contam; respostas corretas mais rápidas dão mais pontos.\n• Bandeiras locais: explore pacotes regionais como estados dos EUA e domine bandeiras locais.\n\n❤️ Sistema de vidas: Perde uma vida sempre que não consegue completar um nível com sucesso. As vidas recarregam automaticamente com o tempo.\n\n💡 Dicas e bónus:\n• Remover 2: elimina duas opções incorretas.\n• Passar automático: completa a bandeira instantaneamente e avança.\n• Pausar temporizador: congela o relógio do Contra o tempo por 3 segundos.\n\n⭐ Estrelas e progresso: Ganhe até três estrelas por nível consoante o seu desempenho. Junte estrelas para desbloquear novos níveis, regiões e pacotes especiais de bandeiras.\n\n🪙 Moedas e recompensas: Completar um nível pela primeira vez dá moedas. Gaste-as na loja em dicas e bónus para avançar mais depressa.\n\n🎁 Bónus diário: Abra uma caixa grátis a cada 24 horas para receber dicas e bónus.",
    homeLeaderboardTitle: "Classificação",
    homeLeaderboardBody:
      "A classificação global está a caminho. Fique atento aos rankings competitivos.",
    leaderboardTopLabel: "Top 100 jogadores • Pontos totais",
    leaderboardLoading: "A carregar classificação...",
    leaderboardError: "Não foi possível carregar a classificação agora.",
    leaderboardEmpty: "Ainda não há pontuações de Contra o tempo.",
    leaderboardLoginRequired:
      "A classificação está disponível apenas para utilizadores com sessão iniciada.",
    "homeInfo.goal.title": "Objetivo",
    "homeInfo.goal.body": "Identifica o país correto para cada bandeira. Quanto mais rápido e preciso fores, melhor será a tua pontuação.",
    "homeInfo.modes.title": "Modos de jogo",
    "homeInfo.modes.classic": "Modo Clássico: joga ao teu ritmo sem pressão de tempo.",
    "homeInfo.modes.timetrial": "Contra o tempo: corre contra o relógio; velocidade e precisão contam.",
    "homeInfo.modes.local": "Bandeiras locais: explora coleções regionais como estados dos EUA e domina as suas bandeiras.",
    "homeInfo.lives.title": "Sistema de vidas",
    "homeInfo.lives.body": "Perdes uma vida sempre que não concluis com sucesso um nível. As vidas recarregam automaticamente com o tempo.",
    "homeInfo.hints.title": "Dicas e impulsionadores",
    "homeInfo.hints.remove2.label": "Remover 2",
    "homeInfo.hints.remove2.body": "Elimina duas opções incorretas.",
    "homeInfo.hints.autopass.label": "Passe automático",
    "homeInfo.hints.autopass.body": "Conclui instantaneamente a bandeira e avança.",
    "homeInfo.hints.pause.label": "Pausar temporizador",
    "homeInfo.hints.pause.body": "Congela o relógio do Contra o tempo por 3 segundos.",
    "homeInfo.stars.title": "Estrelas e progresso",
    "homeInfo.stars.body": "Ganha até três estrelas por nível com base no teu desempenho. Junta estrelas para desbloquear novos níveis, regiões e pacotes especiais.",
    "homeInfo.coins.title": "Moedas e recompensas",
    "homeInfo.coins.body": "Concluir um nível pela primeira vez dá moedas. Gasta-as na loja em dicas e impulsionadores para avançar mais rápido.",
    "homeInfo.daily.title": "Impulsionador diário",
    "homeInfo.daily.body": "Abre uma caixa gratuita a cada 24 horas para receber dicas e bónus.",
    "leaderboard.attempts.one": "{{count}} tentativa",
    "leaderboard.attempts.other": "{{count}} tentativas",

    classic: "Clássico",
    classicDesc: "Aprenda bandeiras no seu ritmo",
    timeTrial: "Contra o tempo",
    timeTrialDesc: "Vença o cronômetro!",
    comingSoon: "Em breve",
    localFlags: "Bandeiras locais",
    localFlagsDesc: "Apenas para jogadores experientes",
    "localFlags.packType.all": "Pacote total",
    "localFlags.packType.country": "Pacote de país",
    "localFlags.packs.all.name": "Todas as bandeiras locais",
    "localFlags.packs.all.short": "Todas",
    "localFlags.packs.ch.name": "Suíça",
    "localFlags.packs.de.name": "Alemanha",
    "localFlags.packs.es.name": "Espanha",
    "localFlags.packs.gb.name": "Reino Unido",
    "localFlags.packs.us.name": "Estados Unidos",

    selectLevel: "Selecionar nível",
    totalStars: "Total",
    locked: "Bloqueado",
    needMoreStars: "Você precisa de mais estrelas para desbloquear esta seção.",
    back: "Voltar",
    coinsPillLabel: "Loja",

    spinForHintsTitle: "Bónus diário",
    youWon: "Ganhaste",
    spinOncePerDay: "Escolha uma caixa uma vez a cada 24 horas",
    claim: "Resgatar",

    profileSettings: "Perfil e definições",
    sound: "Som",
    soundEffectsTitle: "Efeitos sonoros",
    soundEffectsSubtitle: "Reproduzir áudio durante o jogo",
    memberSince: "Membro desde",
    volume: "Volume",
    language: "Idioma",
    logout: "Terminar sessão",
    privacyPolicy: "Política de privacidade",
    termsAndConditions: "Termos e condições",
    areYouSure: "Tens a certeza?",
    close: "Fechar",
    footerTerms: "Termos",
    footerPrivacy: "Privacidade",
    footerContact: "Contacto",
    username: "Nome de utilizador",
    coins: "Moedas",
    storeExtraHeartLabel: "Coração extra",
    storeRefillHeartsLabel: "Repor corações ao máximo",
    storeHeartsFull: "Cheio",

    storeTitle: "Loja de bónus",
    storeSubtitle: "Gasta moedas em dicas ou compra mais moedas.",
    storeYourCoins: "As tuas moedas",
    storeBoostersTitle: "Gasta moedas em bónus",
    storeBoostersDesc: "As dicas de bónus podem ser usadas em qualquer modo.",
    storeCoinPacksTitle: "Obter mais moedas",
    storeCoinPacksDesc:
      "Escolha um pacote para adicionar moedas.",

    storeBuyButton: "Comprar",
    storeNotEnoughCoins: "Moedas insuficientes.",
    storeBoughtBundle: "Compraste 1 de cada dica!",
    storeBoughtSingle: "Compra concluída!",
    storePurchaseCancelled: "Compra cancelada.",
    storeCoinsAdded: "Compra concluída! Moedas adicionadas ao saldo.",
    storeCoinsLabel: "moedas",

    storeRemove2Single: "Remover 2 (x1)",
    storePauseSingle: "Pausar temporizador (x1)",
    storeAutoPassSingle: "Passagem automática (x1)",
    storeAllBundle: "Pack triplo (1 de cada)",

    login: "Entrar",
    createAccount: "Criar conta",
    playAsGuest: "Jogar como convidado",
    entryAccountBenefits: "Guarde o seu progresso, mantenha as suas moedas seguras e jogue em vários dispositivos.",
    maybeLater: "Talvez mais tarde",
    guestPromptTitle: "Mantenha o seu progresso seguro",
    guestPromptBody: "Concluiu {{milestone}} níveis como convidado. Crie uma conta para guardar progresso, moedas e vidas em vários dispositivos.",
    restorePurchases: "Restaurar compras",
    restorePurchasesWorking: "A restaurar compras...",
    restorePurchasesSuccess: "Compras restauradas com sucesso.",
    restorePurchasesFailed: "Não foi possível restaurar as compras agora.",
    deleteAccount: "Eliminar conta",
    deleteAccountConfirmTitle: "Eliminar a conta permanentemente?",
    deleteAccountConfirmBody: "Esta ação não pode ser desfeita. A sua conta será eliminada permanentemente e terminará sessão.",
    deleteAccountConfirmAction: "Sim, eliminar conta",
    cancel: "Cancelar",
    deleting: "A eliminar...",
    level_complete_cta_button: "Criar conta / Entrar",
    level_complete_cta_text: "Guarde o seu progresso ou continue de onde parou.",

    levelWord: "Nível",

    gameOver: "Fim de jogo",
    tryAgain: "Tentar novamente",
    levelComplete: "Nível concluído",
    nextLevel: "Próximo nível",
    goToShop: "Ir à loja",
    goToMainMenu: "Ir ao menu principal",
    timeTrialComplete: "Contra o tempo concluído",
    finalScore: "Pontuação final",
    score: "Pontuação",
    coinsEarnedMessage: "Você ganhou 100 moedas!",

    "hint.title": "Como funcionam as dicas 💡",
    "hint.subtitle": "Use-as para ajudar nas bandeiras difíceis:",
    "hints.removeTwo.label": "Remover 2",
    "hints.removeTwo.description": "Remove duas respostas erradas.",
    "hints.autoPass.label": "Passar automático",
    "hints.autoPass.description": "Escolhe a resposta certa por ti.",
    "hints.pauseTimer.label": "Pausar",
    "hints.pauseTimer.description": "Pausa o tempo por 3 segundos (apenas Contra o tempo).",
    "hints.bundleAll.label": "Pacote triplo (1 de cada)",
    "hint.remove2Label": "Remover 2",
    "hint.remove2Desc": "Remove duas respostas erradas.",
    "hint.autoPassLabel": "Passar automático",
    "hint.autoPassDesc": "Escolhe a resposta certa por ti.",
    "hint.pauseLabel": "Pausar",
    "hint.pauseDesc": "Pausa o tempo por 3 segundos (apenas Contra o tempo).",
    "hint.button": "Dicas",
    "hint.info": "O que fazem as dicas?",
    "hint.notEnough": "Não tens dicas suficientes.",
    ok: "Perfeito",
    loading: "A carregar…",
    loadingChoices: "A carregar opções…",

    dailySpin: "Bónus diário",
    readyToSpin: "Pronto para girar",
    comeBackIn: "Volta em",
    spinForHints: "Roda de bônus",
    spinEveryDay: "Gira uma vez a cada 24 horas",
    spinInfoTitle: "Como funciona",
    spinInfoBody:
      "Escolha uma caixa uma vez por dia para ganhar bónus de dicas grátis.",
    spinToReveal: " ",
    spinNow: "Girar agora",
    spinning: "Girando…",

    "auth.welcome": "Bem-vindo ao FlagIQ",
    "auth.loginTab": "Entrar",
    "auth.signupTab": "Criar conta",

    "auth.emailOrUsername": "E-mail ou nome de utilizador",
    "auth.emailOrUsernamePlaceholder":
      "Insira o seu e-mail ou nome de utilizador",

    "auth.password": "Palavra-passe",
    "auth.passwordPlaceholder": "Insira a sua palavra-passe",

    "auth.username": "Nome de utilizador",
    "auth.usernamePlaceholder": "Escolha um nome de utilizador",
    "auth.usernameHint": "Mínimo de 6 caracteres.",

    "auth.email": "E-mail",
    "auth.emailPlaceholder": "Insira o seu e-mail",
    "auth.emailRequired": "O endereço de e-mail é obrigatório.",
    "auth.emailInvalid": "Por favor, insira um endereço de e-mail válido.",
    "auth.passwordPlaceholder2": "Volta a introduzir a tua nova palavra-passe",

    "auth.show": "Mostrar",
    "auth.hide": "Ocultar",
    "auth.forgot": "Esqueceu-se da palavra-passe?",
    "auth.keepSignedIn": "Manter a sessão iniciada",
    "auth.keepSignedInHelper": "Recomendado em dispositivos pessoais.",
    "auth.passwordHint":
      "Pelo menos 6 caracteres, 1 maiúscula, 1 minúscula e 1 carácter especial.",

    "auth.passwordConfirm": "Confirmar palavra-passe",
"auth.resetTitle": "Redefinir a sua palavra-passe",
"auth.resetIntro": "Escolha uma nova palavra-passe para a sua conta FlagIQ.",
"auth.resetSubmit": "Guardar nova palavra-passe",
"auth.resetSuccess": "A sua palavra-passe foi atualizada. Já pode voltar à aplicação e iniciar sessão.",
"auth.resetMismatch": "As palavras-passe não coincidem.",
"auth.passwordRequired": "Introduza a sua nova palavra-passe.",
"auth.loadingRecoveryLink": "A carregar link de recuperação…",
"auth.resetError": "Não foi possível atualizar a palavra-passe. O link pode ter expirado.",
"auth.passwordReuseError": "Não pode reutilizar uma palavra-passe anterior. Escolha uma nova palavra-passe.",
        "auth.resetInvalid": "Este link de redefinição é inválido ou expirou.",
        "auth.resetNeutral": "Use o link de redefinição de palavra-passe enviado para o seu e-mail.",



    // erros
    "auth.missingCredentials": "Por favor, insira as suas credenciais.",
    "auth.userNotFound": "Utilizador não encontrado.",
    "auth.invalidPassword": "Palavra-passe incorreta.",
    "auth.usernameTooShort":
      "O nome de utilizador deve ter pelo menos 6 caracteres.",
    "auth.usernameTaken": "Esse nome de utilizador já está em uso.",
    "auth.emailInvalid": "Por favor, insira um e-mail válido.",
    "auth.passwordTooShort":
      "A palavra-passe deve ter pelo menos 6 caracteres.",
    "auth.passwordNeedUpper":
      "A palavra-passe deve conter pelo menos uma letra maiúscula.",
    "auth.passwordNeedLower":
      "A palavra-passe deve conter pelo menos uma letra minúscula.",
    "auth.passwordNeedSpecial":
      "A palavra-passe deve conter pelo menos um carácter especial.",

        "auth.resetInfo":
      "Introduza o seu e-mail e enviaremos um link para redefinir a palavra-passe.",
    "auth.resetEmailSent":
      "Se existir uma conta com esse e-mail, receberá em breve um link para redefinir a palavra-passe.",
    "auth.resetError":
      "Não foi possível enviar o link de redefinição. Tente novamente.",
    "auth.sendResetLink": "Enviar link de redefinição",
    "auth.backToLogin": "Voltar ao início de sessão",


    "flag.Afghanistan": "Afeganistão",
    "flag.Albania": "Albânia",
    "flag.Algeria": "Argélia",
    "flag.American Samoa": "Samoa Americana",
    "flag.Andorra": "Andorra",
    "flag.Angola": "Angola",
    "flag.Anguilla": "Anguila",
    "flag.Antarctica": "Antártida",
    "flag.Antigua and Barbuda": "Antígua e Barbuda",
    "flag.Argentina": "Argentina",
    "flag.Armenia": "Arménia",
    "flag.Aruba": "Aruba",
    "flag.Australia": "Austrália",
    "flag.Austria": "Áustria",
    "flag.Azerbaijan": "Azerbaijão",
    "flag.Bahamas": "Bahamas",
    "flag.Bahrain": "Barém",
    "flag.Bangladesh": "Bangladeche",
    "flag.Barbados": "Barbados",
    "flag.Belarus": "Bielorrússia",
    "flag.Belgium": "Bélgica",
    "flag.Belize": "Belize",
    "flag.Benin": "Benim",
    "flag.Bermuda": "Bermudas",
    "flag.Bhutan": "Butão",
    "flag.Bolivia": "Bolívia",
    "flag.Bonaire": "Bonaire",
    "flag.Bosnia and Herzegovina": "Bósnia e Herzegovina",
    "flag.Botswana": "Botsuana",
    "flag.Brazil": "Brasil",
    "flag.British Indian Ocean Territory":
      "Território Britânico do Oceano Índico",
    "flag.British Virgin Islands": "Ilhas Virgens Britânicas",
    "flag.Brunei": "Brunei",
    "flag.Bulgaria": "Bulgária",
    "flag.Burkina Faso": "Burquina Faso",
    "flag.Burundi": "Burúndi",
    "flag.Cambodia": "Camboja",
    "flag.Cameroon": "Camarões",
    "flag.Canada": "Canadá",
    "flag.Cape Verde": "Cabo Verde",
    "flag.Cayman Islands": "Ilhas Caimão",
    "flag.Central African Republic": "República Centro-Africana",
    "flag.Chad": "Chade",
    "flag.Chile": "Chile",
    "flag.China": "China",
    "flag.Christmas Island": "Ilha do Natal",
    "flag.Cocos (Keeling) Islands": "Ilhas Cocos",
    "flag.Colombia": "Colômbia",
    "flag.Comoros": "Comores",
    "flag.Congo (DRC)": "República Democrática do Congo",
    "flag.Congo (Republic)": "República do Congo",
    "flag.Cook Islands": "Ilhas Cook",
    "flag.Costa Rica": "Costa Rica",
    "flag.Croatia": "Croácia",
    "flag.Cuba": "Cuba",
    "flag.Curaçao": "Curaçau",
    "flag.Cyprus": "Chipre",
    "flag.Czech Republic": "Chéquia",
    "flag.Denmark": "Dinamarca",
    "flag.Djibouti": "Jibuti",
    "flag.Dominica": "Dominica",
    "flag.Dominican Republic": "República Dominicana",
    "flag.Ecuador": "Equador",
    "flag.Egypt": "Egito",
    "flag.El Salvador": "El Salvador",
    "flag.England": "Inglaterra",
    "flag.Equatorial Guinea": "Guiné Equatorial",
    "flag.Eritrea": "Eritreia",
    "flag.Estonia": "Estónia",
    "flag.Eswatini": "Essuatíni",
    "flag.Ethiopia": "Etiópia",
    "flag.Falkland Islands": "Ilhas Malvinas",
    "flag.Faroe Islands": "Ilhas Faroé",
    "flag.Fiji": "Fiji",
    "flag.Finland": "Finlândia",
    "flag.France": "França",
    "flag.French Guiana": "Guiana Francesa",
    "flag.French Polynesia": "Polinésia Francesa",
    "flag.Gabon": "Gabão",
    "flag.Gambia": "Gâmbia",
    "flag.Georgia": "Geórgia",
    "flag.Germany": "Alemanha",
    "flag.Ghana": "Gana",
    "flag.Gibraltar": "Gibraltar",
    "flag.Greece": "Grécia",
    "flag.Greenland": "Gronelândia",
    "flag.Grenada": "Granada",
    "flag.Guadeloupe": "Guadalupe",
    "flag.Guatemala": "Guatemala",
    "flag.Guernsey": "Guernsey",
    "flag.Guinea": "Guiné",
    "flag.Guinea-Bissau": "Guiné-Bissau",
    "flag.Guyana": "Guiana",
    "flag.Haiti": "Haiti",
    "flag.Honduras": "Honduras",
    "flag.Hong Kong": "Hong Kong",
    "flag.Hungary": "Hungria",
    "flag.Iceland": "Islândia",
    "flag.India": "Índia",
    "flag.Indonesia": "Indonésia",
    "flag.Iran": "Irão",
    "flag.Iraq": "Iraque",
    "flag.Ireland": "Irlanda",
    "flag.Isle of Man": "Ilha de Man",
    "flag.Israel": "Israel",
    "flag.Italy": "Itália",
    "flag.Ivory Coast": "Costa do Marfim",
    "flag.Jamaica": "Jamaica",
    "flag.Japan": "Japão",
    "flag.Jersey": "Jersey",
    "flag.Jordan": "Jordânia",
    "flag.Kazakhstan": "Cazaquistão",
    "flag.Kenya": "Quénia",
    "flag.Kiribati": "Quiribáti",
    "flag.Kosovo": "Kosovo",
    "flag.Kuwait": "Kuwait",
    "flag.Kyrgyzstan": "Quirguistão",
    "flag.Laos": "Laos",
    "flag.Latvia": "Letónia",
    "flag.Lebanon": "Líbano",
    "flag.Lesotho": "Lesoto",
    "flag.Liberia": "Libéria",
    "flag.Libya": "Líbia",
    "flag.Liechtenstein": "Liechtenstein",
    "flag.Lithuania": "Lituânia",
    "flag.Luxembourg": "Luxemburgo",
    "flag.Macau": "Macau",
    "flag.Madagascar": "Madagáscar",
    "flag.Malawi": "Maláui",
    "flag.Malaysia": "Malásia",
    "flag.Maldives": "Maldivas",
    "flag.Mali": "Mali",
    "flag.Malta": "Malta",
    "flag.Marshall Islands": "Ilhas Marshall",
    "flag.Martinique": "Martinica",
    "flag.Mauritania": "Mauritânia",
    "flag.Mauritius": "Maurícia",
    "flag.Mayotte": "Mayotte",
    "flag.Mexico": "México",
    "flag.Micronesia": "Micronésia",
    "flag.Moldova": "Moldávia",
    "flag.Monaco": "Mónaco",
    "flag.Mongolia": "Mongólia",
    "flag.Montenegro": "Montenegro",
    "flag.Montserrat": "Montserrat",
    "flag.Morocco": "Marrocos",
    "flag.Mozambique": "Moçambique",
    "flag.Myanmar": "Mianmar",
    "flag.Namibia": "Namíbia",
    "flag.Nauru": "Nauru",
    "flag.Nepal": "Nepal",
    "flag.Netherlands": "Países Baixos",
    "flag.New Caledonia": "Nova Caledónia",
    "flag.New Zealand": "Nova Zelândia",
    "flag.Nicaragua": "Nicarágua",
    "flag.Niger": "Níger",
    "flag.Nigeria": "Nigéria",
    "flag.Niue": "Niue",
    "flag.Norfolk Island": "Ilha Norfolk",
    "flag.North Korea": "Coreia do Norte",
    "flag.North Macedonia": "Macedónia do Norte",
    "flag.Northern Ireland": "Irlanda do Norte",
    "flag.Northern Mariana Islands": "Ilhas Marianas do Norte",
    "flag.Norway": "Noruega",
    "flag.Oman": "Omã",
    "flag.Pakistan": "Paquistão",
    "flag.Palau": "Palau",
    "flag.Palestine": "Palestina",
    "flag.Panama": "Panamá",
    "flag.Papua New Guinea": "Papua-Nova Guiné",
    "flag.Paraguay": "Paraguai",
    "flag.Peru": "Peru",
    "flag.Philippines": "Filipinas",
    "flag.Pitcairn Islands": "Ilhas Pitcairn",
    "flag.Poland": "Polónia",
    "flag.Portugal": "Portugal",
    "flag.Puerto Rico": "Porto Rico",
    "flag.Qatar": "Catar",
    "flag.Reunion": "Reunião",
    "flag.Romania": "Roménia",
    "flag.Russia": "Rússia",
    "flag.Rwanda": "Ruanda",
    "flag.Saint Barthélemy": "São Bartolomeu",
    "flag.Saint Helena": "Santa Helena",
    "flag.Saint Kitts and Nevis": "São Cristóvão e Neves",
    "flag.Saint Lucia": "Santa Lúcia",
    "flag.Saint Martin": "São Martinho",
    "flag.Saint Pierre and Miquelon": "São Pedro e Miquelon",
    "flag.Saint Vincent and the Grenadines": "São Vicente e Granadinas",
    "flag.Samoa": "Samoa",
    "flag.San Marino": "São Marinho",
    "flag.Sao Tome and Principe": "São Tomé e Príncipe",
    "flag.Saudi Arabia": "Arábia Saudita",
    "flag.Scotland": "Escócia",
    "flag.Senegal": "Senegal",
    "flag.Serbia": "Sérvia",
    "flag.Seychelles": "Seicheles",
    "flag.Sierra Leone": "Serra Leoa",
    "flag.Singapore": "Singapura",
    "flag.Sint Maarten": "São Martinho (Países Baixos)",
    "flag.Slovakia": "Eslováquia",
    "flag.Slovenia": "Eslovénia",
    "flag.Solomon Islands": "Ilhas Salomão",
    "flag.Somalia": "Somália",
    "flag.South Africa": "África do Sul",
    "flag.South Korea": "Coreia do Sul",
    "flag.South Sudan": "Sudão do Sul",
    "flag.Spain": "Espanha",
    "flag.Sri Lanka": "Sri Lanca",
    "flag.Sudan": "Sudão",
    "flag.Suriname": "Suriname",
    "flag.Sweden": "Suécia",
    "flag.Switzerland": "Suíça",
    "flag.Syria": "Síria",
    "flag.Taiwan": "Taiwan",
    "flag.Tajikistan": "Tajiquistão",
    "flag.Tanzania": "Tanzânia",
    "flag.Thailand": "Tailândia",
    "flag.Timor-Leste": "Timor-Leste",
    "flag.Togo": "Togo",
    "flag.Tokelau": "Toquelau",
    "flag.Tonga": "Tonga",
    "flag.Trinidad and Tobago": "Trindade e Tobago",
    "flag.Tunisia": "Tunísia",
    "flag.Turkey": "Turquia",
    "flag.Turkmenistan": "Turquemenistão",
    "flag.Turks and Caicos Islands": "Ilhas Turcas e Caicos",
    "flag.Tuvalu": "Tuvalu",
    "flag.Uganda": "Uganda",
    "flag.Ukraine": "Ucrânia",
    "flag.United Arab Emirates": "Emirados Árabes Unidos",
    "flag.United Kingdom": "Reino Unido",
    "flag.United States": "Estados Unidos",
    "flag.Uruguay": "Uruguai",
    "flag.Uzbekistan": "Usbequistão",
    "flag.Vanuatu": "Vanuatu",
    "flag.Vatican City": "Vaticano",
    "flag.Venezuela": "Venezuela",
    "flag.Vietnam": "Vietname",
    "flag.Wales": "País de Gales",
    "flag.Wallis and Futuna": "Wallis e Futuna",
    "flag.Western Sahara": "Saara Ocidental",
    "flag.Yemen": "Iémen",
    "flag.Zambia": "Zâmbia",
    "flag.Zimbabwe": "Zimbabué",
    "flag.Guam": "Guam",
    "flag.U.S. Virgin Islands": "Ilhas Virgens Americanas",
    "flag.South Georgia and South Sandwich Islands":
      "Geórgia do Sul e Ilhas Sanduíche do Sul",
    "flag.Curacao": "Curaçau",
    "flag.Ascension Island": "Ilha de Ascensão",
  },

  de: {
    appTitle: "FlagIQ",
    appSubtitle: "Teste dein Weltwissen – Fahne für Fahne",
    homeInfoTitle: "So spielst du",
    homeInfoBody:
      "🎯 Ziel: Erkenne für jede Flagge das richtige Land. Je schneller und genauer du bist, desto besser ist deine Punktzahl.\n\n🎮 Spielmodi:\n• Klassischer Modus: spiele in deinem Tempo ohne Zeitdruck.\n• Zeitmodus: gegen die Uhr, bei dem Tempo und Genauigkeit zählen; schnellere richtige Antworten bringen höhere Punkte.\n• Lokale Flaggen: erkunde regionale Pakete wie US-Bundesstaaten und meistere lokale Flaggen.\n\n❤️ Lebenssystem: Du verlierst ein Leben, wenn du ein Level nicht erfolgreich abschließt. Leben füllen sich mit der Zeit automatisch wieder auf.\n\n💡 Hinweise & Booster:\n• 2 entfernen: entfernt zwei falsche Optionen.\n• Auto-Lösen: löst die Flagge sofort und bringt dich weiter.\n• Timer-Pause: stoppt die Zeit im Zeitmodus für 3 Sekunden.\n\n⭐ Sterne & Fortschritt: Verdiene bis zu drei Sterne pro Level je nach Leistung. Sammle Sterne, um neue Level, Regionen und spezielle Flaggen-Packs freizuschalten.\n\n🪙 Münzen & Belohnungen: Das erste Abschließen eines Levels gibt Münzen. Gib sie im Shop für Hinweise und Booster aus, um schneller voranzukommen.\n\n🎁 Täglicher Booster: Öffne alle 24 Stunden eine kostenlose Box, um Hinweise und Booster zu erhalten.",
    homeLeaderboardTitle: "Bestenliste",
    homeLeaderboardBody:
      "Die globale Bestenliste ist unterwegs. Bleib dran für Wettbewerbsrankings.",
    leaderboardTopLabel: "Top 100 Spieler • Gesamtpunkte",
    leaderboardLoading: "Bestenliste wird geladen...",
    leaderboardError: "Bestenliste kann derzeit nicht geladen werden.",
    leaderboardEmpty: "Noch keine Zeitmodus-Ergebnisse.",
    leaderboardLoginRequired:
      "Die Bestenliste ist nur für eingeloggte Nutzer verfügbar.",
    "homeInfo.goal.title": "Ziel",
    "homeInfo.goal.body": "Ordne jeder Flagge das richtige Land zu. Je schneller und genauer du bist, desto besser ist deine Punktzahl.",
    "homeInfo.modes.title": "Spielmodi",
    "homeInfo.modes.classic": "Klassischer Modus: Spiele ohne Zeitdruck in deinem eigenen Tempo.",
    "homeInfo.modes.timetrial": "Zeitrennen: Spiele gegen die Uhr – Geschwindigkeit und Genauigkeit zählen.",
    "homeInfo.modes.local": "Lokale Flaggen: Erkunde regionale Pakete wie US-Bundesstaaten und meistere ihre Flaggen.",
    "homeInfo.lives.title": "Leben-System",
    "homeInfo.lives.body": "Du verlierst ein Leben, wenn du ein Level nicht erfolgreich abschließt. Leben füllen sich mit der Zeit automatisch auf.",
    "homeInfo.hints.title": "Hinweise & Booster",
    "homeInfo.hints.remove2.label": "2 entfernen",
    "homeInfo.hints.remove2.body": "Entfernt zwei falsche Optionen.",
    "homeInfo.hints.autopass.label": "Auto-Pass",
    "homeInfo.hints.autopass.body": "Schließt die Flagge sofort ab und bringt dich weiter.",
    "homeInfo.hints.pause.label": "Timer pausieren",
    "homeInfo.hints.pause.body": "Hält die Zeit im Zeitrennen für 3 Sekunden an.",
    "homeInfo.stars.title": "Sterne & Fortschritt",
    "homeInfo.stars.body": "Verdiene bis zu drei Sterne pro Level. Sammle Sterne, um neue Levels, Regionen und Spezialpakete freizuschalten.",
    "homeInfo.coins.title": "Münzen & Belohnungen",
    "homeInfo.coins.body": "Beim ersten Abschluss eines Levels erhältst du Münzen. Nutze sie im Shop für Hinweise und Booster.",
    "homeInfo.daily.title": "Täglicher Booster",
    "homeInfo.daily.body": "Öffne alle 24 Stunden eine kostenlose Booster-Box für Hinweise und Boni.",
    "leaderboard.attempts.one": "{{count}} Versuch",
    "leaderboard.attempts.other": "{{count}} Versuche",

    classic: "Klassisch",
    classicDesc: "Lerne Flaggen in deinem Tempo",
    timeTrial: "Zeitmodus",
    timeTrialDesc: "Schlag die Zeit!",
    comingSoon: "Kommt bald",
    localFlags: "Lokale Flaggen",
    localFlagsDesc: "Nur für erfahrene Spieler",
    "localFlags.packType.all": "Gesamtpaket",
    "localFlags.packType.country": "Länderpaket",
    "localFlags.packs.all.name": "Alle lokalen Flaggen",
    "localFlags.packs.all.short": "Alle",
    "localFlags.packs.ch.name": "Schweiz",
    "localFlags.packs.de.name": "Deutschland",
    "localFlags.packs.es.name": "Spanien",
    "localFlags.packs.gb.name": "Vereinigtes Königreich",
    "localFlags.packs.us.name": "Vereinigte Staaten",

    selectLevel: "Level wählen",
    totalStars: "Gesamt",
    locked: "Gesperrt",
    needMoreStars:
      "Du brauchst mehr Sterne, um diesen Abschnitt freizuschalten.",
    back: "Zurück",
    coinsPillLabel: "Shop",

    profileSettings: "Profil & Einstellungen",
    sound: "Ton",
    soundEffectsTitle: "Soundeffekte",
    soundEffectsSubtitle: "Audiofeedback während des Spiels",
    memberSince: "Mitglied seit",
    volume: "Lautstärke",
    language: "Sprache",
    logout: "Abmelden",
    privacyPolicy: "Datenschutzerklärung",
    termsAndConditions: "AGB",
    areYouSure: "Bist du sicher?",
    close: "Schließen",
    footerTerms: "AGB",
    footerPrivacy: "Datenschutz",
    footerContact: "Kontakt",
    username: "Benutzername",
    coins: "Münzen",
    storeExtraHeartLabel: "Extra-Herz",
    storeRefillHeartsLabel: "Herzen vollständig auffüllen",
    storeHeartsFull: "Voll",

    spinForHintsTitle: "Täglicher Booster",
    youWon: "Du hast gewonnen",
    spinOncePerDay: "Wähle einmal alle 24 Stunden eine Box",
    claim: "Einlösen",

    login: "Anmelden",
    createAccount: "Konto erstellen",
    playAsGuest: "Als Gast spielen",
    entryAccountBenefits: "Speichere deinen Fortschritt, sichere deine Münzen und spiele auf mehreren Geräten.",
    maybeLater: "Vielleicht später",
    guestPromptTitle: "Sichere deinen Fortschritt",
    guestPromptBody: "Du hast {{milestone}} Level als Gast abgeschlossen. Erstelle ein Konto, um Fortschritt, Münzen und Leben geräteübergreifend zu speichern.",
    restorePurchases: "Käufe wiederherstellen",
    restorePurchasesWorking: "Käufe werden wiederhergestellt...",
    restorePurchasesSuccess: "Käufe erfolgreich wiederhergestellt.",
    restorePurchasesFailed: "Käufe konnten gerade nicht wiederhergestellt werden.",
    deleteAccount: "Konto löschen",
    deleteAccountConfirmTitle: "Konto dauerhaft löschen?",
    deleteAccountConfirmBody: "Diese Aktion kann nicht rückgängig gemacht werden. Dein Konto wird dauerhaft gelöscht und du wirst abgemeldet.",
    deleteAccountConfirmAction: "Ja, Konto löschen",
    cancel: "Abbrechen",
    deleting: "Wird gelöscht...",
    level_complete_cta_button: "Konto erstellen / Anmelden",
    level_complete_cta_text: "Speichere deinen Fortschritt oder mache dort weiter, wo du aufgehört hast.",

    storeTitle: "Booster-Shop",
    storeSubtitle: "Gib Münzen für Hinweise aus oder hol dir mehr Münzen.",
    storeYourCoins: "Deine Münzen",
    storeBoostersTitle: "Booster mit Münzen kaufen",
    storeBoostersDesc: "Booster-Hinweise funktionieren in jedem Modus.",
    storeCoinPacksTitle: "Mehr Münzen erhalten",
    storeCoinPacksDesc:
      "Wähle ein Paket, um Münzen hinzuzufügen.",

    storeBuyButton: "Kaufen",
    storeNotEnoughCoins: "Nicht genug Münzen.",
    storeBoughtBundle: "Du hast je einen von allen Hinweisen gekauft!",
    storeBoughtSingle: "Kauf erfolgreich!",
    storePurchaseCancelled: "Kauf abgebrochen.",
    storeCoinsAdded: "Kauf erfolgreich! Münzen wurden deinem Guthaben hinzugefügt.",
    storeCoinsLabel: "Münzen",

    storeRemove2Single: "Zwei entfernen (x1)",
    storePauseSingle: "Timer pausieren (x1)",
    storeAutoPassSingle: "Auto-Pass (x1)",
    storeAllBundle: "Dreierpaket (je 1)",

    levelWord: "Level",

    gameOver: "Spiel vorbei",
    tryAgain: "Nochmal",
    levelComplete: "Level abgeschlossen",
    nextLevel: "Nächstes Level",
    goToShop: "Zum Shop",
    goToMainMenu: "Zum Hauptmenü",
    timeTrialComplete: "Zeitlauf abgeschlossen",
    finalScore: "Endpunktzahl",
    score: "Punktzahl",

    coinsEarnedMessage: "Du hast 100 Münzen verdient!",

    "hint.title": "So funktionieren die Hinweise 💡",
    "hint.subtitle": "Nutze sie für schwierige Flaggen:",
    "hints.removeTwo.label": "2 entfernen",
    "hints.removeTwo.description": "Entfernt zwei falsche Antworten.",
    "hints.autoPass.label": "Auto-Lösen",
    "hints.autoPass.description": "Wählt die richtige Antwort für dich.",
    "hints.pauseTimer.label": "Pause",
    "hints.pauseTimer.description": "Pausiert den Timer für 3 Sekunden (nur Zeitmodus).",
    "hints.bundleAll.label": "Dreierpack (je 1)",
    "hint.remove2Label": "2 entfernen",
    "hint.remove2Desc": "Entfernt zwei falsche Antworten.",
    "hint.autoPassLabel": "Auto-Lösen",
    "hint.autoPassDesc": "Wählt die richtige Antwort für dich.",
    "hint.pauseLabel": "Pause",
    "hint.pauseDesc": "Pausiert den Timer für 3 Sekunden (nur Zeitmodus).",
    "hint.button": "Hinweise",
    "hint.info": "Was machen die Hinweise?",
    "hint.notEnough": "Nicht genug Hinweise.",
    ok: "Alles klar",
    loading: "Wird geladen…",
    loadingChoices: "Antworten werden geladen…",

    dailySpin: "Täglicher Booster",
    readyToSpin: "Bereit zum Drehen",
    comeBackIn: "Komm zurück in",
    spinForHints: "Booster-Rad",
    spinEveryDay: "Einmal alle 24 Stunden drehen",
    spinInfoTitle: "So funktioniert’s",
    spinInfoBody:
      "Wähle einmal täglich eine Box für kostenlose Hinweis-Boosts.",
    spinToReveal: " ",
    spinNow: "Jetzt drehen",
    spinning: "Dreht sich…",

    "auth.welcome": "Willkommen bei FlagIQ",
    "auth.loginTab": "Anmelden",
    "auth.signupTab": "Konto erstellen",

    "auth.emailOrUsername": "E-Mail oder Benutzername",
    "auth.emailOrUsernamePlaceholder":
      "Gib deine E-Mail oder deinen Benutzernamen ein",

    "auth.password": "Passwort",
    "auth.passwordPlaceholder": "Gib dein Passwort ein",

    "auth.username": "Benutzername",
    "auth.usernamePlaceholder": "Wähle einen Benutzernamen",
    "auth.usernameHint": "Mindestens 6 Zeichen.",

    "auth.email": "E-Mail",
    "auth.emailPlaceholder": "Gib deine E-Mail ein",
    "auth.emailRequired": "E-Mail-Adresse ist erforderlich.",
    "auth.emailInvalid": "Bitte gib eine gültige E-Mail-Adresse ein.",

    "auth.show": "Anzeigen",
    "auth.hide": "Verbergen",
    "auth.forgot": "Passwort vergessen?",
    "auth.keepSignedIn": "Angemeldet bleiben",
    "auth.keepSignedInHelper": "Empfohlen auf persönlichen Geräten.",
    "auth.passwordHint":
      "Mindestens 6 Zeichen, 1 Großbuchstabe, 1 Kleinbuchstabe, 1 Sonderzeichen.",

    "auth.passwordConfirm": "Passwort bestätigen",
"auth.resetTitle": "Neues Passwort festlegen",
"auth.resetIntro": "Wähle ein neues Passwort für dein FlagIQ-Konto.",
"auth.resetSubmit": "Neues Passwort speichern",
"auth.resetSuccess": "Dein Passwort wurde aktualisiert. Du kannst jetzt zur App zurückkehren und dich einloggen.",
"auth.resetMismatch": "Die Passwörter stimmen nicht überein.",
"auth.passwordRequired": "Bitte gib dein neues Passwort ein.",
"auth.loadingRecoveryLink": "Wiederherstellungslink wird geladen…",
"auth.resetError": "Dein Passwort konnte nicht aktualisiert werden. Der Link ist möglicherweise abgelaufen.",
"auth.passwordReuseError": "Du kannst kein früheres Passwort verwenden. Bitte wähle ein neues Passwort.",
        "auth.resetInvalid": "Dieser Zurücksetzungslink ist ungültig oder abgelaufen.",
        "auth.resetNeutral": "Bitte verwende den Link zum Zurücksetzen des Passworts aus deiner E-Mail.",
    "auth.passwordPlaceholder2": "Gib dein neues Passwort erneut ein",



    // Fehler
    "auth.missingCredentials": "Bitte gib deine Anmeldedaten ein.",
    "auth.userNotFound": "Benutzer nicht gefunden.",
    "auth.invalidPassword": "Falsches Passwort.",
    "auth.usernameTooShort":
      "Der Benutzername muss mindestens 6 Zeichen lang sein.",
    "auth.usernameTaken": "Dieser Benutzername ist bereits vergeben.",
    "auth.emailInvalid": "Bitte gib eine gültige E-Mail-Adresse ein.",
    "auth.passwordTooShort":
      "Das Passwort muss mindestens 6 Zeichen lang sein.",
    "auth.passwordNeedUpper":
      "Das Passwort muss mindestens einen Großbuchstaben enthalten.",
    "auth.passwordNeedLower":
      "Das Passwort muss mindestens einen Kleinbuchstaben enthalten.",
    "auth.passwordNeedSpecial":
      "Das Passwort muss mindestens ein Sonderzeichen enthalten.",

        "auth.resetInfo":
      "Gib deine E-Mail ein und wir schicken dir einen Link zum Zurücksetzen deines Passworts.",
    "auth.resetEmailSent":
      "Wenn ein Konto mit dieser E-Mail existiert, erhältst du in Kürze einen Link zum Zurücksetzen.",
    "auth.resetError":
      "Der Zurücksetzungslink konnte nicht gesendet werden. Bitte versuche es erneut.",
    "auth.sendResetLink": "Zurücksetzlink senden",
    "auth.backToLogin": "Zurück zur Anmeldung",


    "flag.Afghanistan": "Afghanistan",
    "flag.Albania": "Albanien",
    "flag.Algeria": "Algerien",
    "flag.American Samoa": "Amerikanisch-Samoa",
    "flag.Andorra": "Andorra",
    "flag.Angola": "Angola",
    "flag.Anguilla": "Anguilla",
    "flag.Antarctica": "Antarktis",
    "flag.Antigua and Barbuda": "Antigua und Barbuda",
    "flag.Argentina": "Argentinien",
    "flag.Armenia": "Armenien",
    "flag.Aruba": "Aruba",
    "flag.Australia": "Australien",
    "flag.Austria": "Österreich",
    "flag.Azerbaijan": "Aserbaidschan",
    "flag.Bahamas": "Bahamas",
    "flag.Bahrain": "Bahrain",
    "flag.Bangladesh": "Bangladesch",
    "flag.Barbados": "Barbados",
    "flag.Belarus": "Belarus",
    "flag.Belgium": "Belgien",
    "flag.Belize": "Belize",
    "flag.Benin": "Benin",
    "flag.Bermuda": "Bermuda",
    "flag.Bhutan": "Bhutan",
    "flag.Bolivia": "Bolivien",
    "flag.Bonaire": "Bonaire",
    "flag.Bosnia and Herzegovina": "Bosnien und Herzegowina",
    "flag.Botswana": "Botswana",
    "flag.Brazil": "Brasilien",
    "flag.British Indian Ocean Territory":
      "Britisches Territorium im Indischen Ozean",
    "flag.British Virgin Islands": "Britische Jungferninseln",
    "flag.Brunei": "Brunei",
    "flag.Bulgaria": "Bulgarien",
    "flag.Burkina Faso": "Burkina Faso",
    "flag.Burundi": "Burundi",
    "flag.Cambodia": "Kambodscha",
    "flag.Cameroon": "Kamerun",
    "flag.Canada": "Kanada",
    "flag.Cape Verde": "Kap Verde",
    "flag.Cayman Islands": "Kaimaninseln",
    "flag.Central African Republic": "Zentralafrikanische Republik",
    "flag.Chad": "Tschad",
    "flag.Chile": "Chile",
    "flag.China": "China",
    "flag.Christmas Island": "Weihnachtsinsel",
    "flag.Cocos (Keeling) Islands": "Kokosinseln",
    "flag.Colombia": "Kolumbien",
    "flag.Comoros": "Komoren",
    "flag.Congo (DRC)": "Demokratische Republik Kongo",
    "flag.Congo (Republic)": "Republik Kongo",
    "flag.Cook Islands": "Cookinseln",
    "flag.Costa Rica": "Costa Rica",
    "flag.Croatia": "Kroatien",
    "flag.Cuba": "Kuba",
    "flag.Curaçao": "Curaçao",
    "flag.Cyprus": "Zypern",
    "flag.Czech Republic": "Tschechien",
    "flag.Denmark": "Dänemark",
    "flag.Djibouti": "Dschibuti",
    "flag.Dominica": "Dominica",
    "flag.Dominican Republic": "Dominikanische Republik",
    "flag.Ecuador": "Ecuador",
    "flag.Egypt": "Ägypten",
    "flag.El Salvador": "El Salvador",
    "flag.England": "England",
    "flag.Equatorial Guinea": "Äquatorialguinea",
    "flag.Eritrea": "Eritrea",
    "flag.Estonia": "Estland",
    "flag.Eswatini": "Eswatini",
    "flag.Ethiopia": "Äthiopien",
    "flag.Falkland Islands": "Falklandinseln",
    "flag.Faroe Islands": "Färöer-Inseln",
    "flag.Fiji": "Fidschi",
    "flag.Finland": "Finnland",
    "flag.France": "Frankreich",
    "flag.French Guiana": "Französisch-Guayana",
    "flag.French Polynesia": "Französisch-Polynesien",
    "flag.Gabon": "Gabun",
    "flag.Gambia": "Gambia",
    "flag.Georgia": "Georgien",
    "flag.Germany": "Deutschland",
    "flag.Ghana": "Ghana",
    "flag.Gibraltar": "Gibraltar",
    "flag.Greece": "Griechenland",
    "flag.Greenland": "Grönland",
    "flag.Grenada": "Grenada",
    "flag.Guadeloupe": "Guadeloupe",
    "flag.Guatemala": "Guatemala",
    "flag.Guernsey": "Guernsey",
    "flag.Guinea": "Guinea",
    "flag.Guinea-Bissau": "Guinea-Bissau",
    "flag.Guyana": "Guyana",
    "flag.Haiti": "Haiti",
    "flag.Honduras": "Honduras",
    "flag.Hong Kong": "Hongkong",
    "flag.Hungary": "Ungarn",
    "flag.Iceland": "Island",
    "flag.India": "Indien",
    "flag.Indonesia": "Indonesien",
    "flag.Iran": "Iran",
    "flag.Iraq": "Irak",
    "flag.Ireland": "Irland",
    "flag.Isle of Man": "Isle of Man",
    "flag.Israel": "Israel",
    "flag.Italy": "Italien",
    "flag.Ivory Coast": "Elfenbeinküste",
    "flag.Jamaica": "Jamaika",
    "flag.Japan": "Japan",
    "flag.Jersey": "Jersey",
    "flag.Jordan": "Jordanien",
    "flag.Kazakhstan": "Kasachstan",
    "flag.Kenya": "Kenia",
    "flag.Kiribati": "Kiribati",
    "flag.Kosovo": "Kosovo",
    "flag.Kuwait": "Kuwait",
    "flag.Kyrgyzstan": "Kirgisistan",
    "flag.Laos": "Laos",
    "flag.Latvia": "Lettland",
    "flag.Lebanon": "Libanon",
    "flag.Lesotho": "Lesotho",
    "flag.Liberia": "Liberia",
    "flag.Libya": "Libyen",
    "flag.Liechtenstein": "Liechtenstein",
    "flag.Lithuania": "Litauen",
    "flag.Luxembourg": "Luxemburg",
    "flag.Macau": "Macau",
    "flag.Madagascar": "Madagaskar",
    "flag.Malawi": "Malawi",
    "flag.Malaysia": "Malaysia",
    "flag.Maldives": "Malediven",
    "flag.Mali": "Mali",
    "flag.Malta": "Malta",
    "flag.Marshall Islands": "Marshallinseln",
    "flag.Martinique": "Martinique",
    "flag.Mauritania": "Mauretanien",
    "flag.Mauritius": "Mauritius",
    "flag.Mayotte": "Mayotte",
    "flag.Mexico": "Mexiko",
    "flag.Micronesia": "Mikronesien",
    "flag.Moldova": "Moldawien",
    "flag.Monaco": "Monaco",
    "flag.Mongolia": "Mongolei",
    "flag.Montenegro": "Montenegro",
    "flag.Montserrat": "Montserrat",
    "flag.Morocco": "Marokko",
    "flag.Mozambique": "Mosambik",
    "flag.Myanmar": "Myanmar",
    "flag.Namibia": "Namibia",
    "flag.Nauru": "Nauru",
    "flag.Nepal": "Nepal",
    "flag.Netherlands": "Niederlande",
    "flag.New Caledonia": "Neukaledonien",
    "flag.New Zealand": "Neuseeland",
    "flag.Nicaragua": "Nicaragua",
    "flag.Niger": "Niger",
    "flag.Nigeria": "Nigeria",
    "flag.Niue": "Niue",
    "flag.Norfolk Island": "Norfolkinsel",
    "flag.North Korea": "Nordkorea",
    "flag.North Macedonia": "Nordmazedonien",
    "flag.Northern Ireland": "Nordirland",
    "flag.Northern Mariana Islands": "Nördliche Marianen",
    "flag.Norway": "Norwegen",
    "flag.Oman": "Oman",
    "flag.Pakistan": "Pakistan",
    "flag.Palau": "Palau",
    "flag.Palestine": "Palästina",
    "flag.Panama": "Panama",
    "flag.Papua New Guinea": "Papua-Neuguinea",
    "flag.Paraguay": "Paraguay",
    "flag.Peru": "Peru",
    "flag.Philippines": "Philippinen",
    "flag.Pitcairn Islands": "Pitcairninseln",
    "flag.Poland": "Polen",
    "flag.Portugal": "Portugal",
    "flag.Puerto Rico": "Puerto Rico",
    "flag.Qatar": "Katar",
    "flag.Reunion": "Réunion",
    "flag.Romania": "Rumänien",
    "flag.Russia": "Russland",
    "flag.Rwanda": "Ruanda",
    "flag.Saint Barthélemy": "Saint-Barthélemy",
    "flag.Saint Helena": "St. Helena",
    "flag.Saint Kitts and Nevis": "St. Kitts und Nevis",
    "flag.Saint Lucia": "St. Lucia",
    "flag.Saint Martin": "Saint-Martin",
    "flag.Saint Pierre and Miquelon": "Saint-Pierre und Miquelon",
    "flag.Saint Vincent and the Grenadines": "St. Vincent und die Grenadinen",
    "flag.Samoa": "Samoa",
    "flag.San Marino": "San Marino",
    "flag.Sao Tome and Principe": "São Tomé und Príncipe",
    "flag.Saudi Arabia": "Saudi-Arabien",
    "flag.Scotland": "Schottland",
    "flag.Senegal": "Senegal",
    "flag.Serbia": "Serbien",
    "flag.Seychelles": "Seychellen",
    "flag.Sierra Leone": "Sierra Leone",
    "flag.Singapore": "Singapur",
    "flag.Sint Maarten": "Sint Maarten",
    "flag.Slovakia": "Slowakei",
    "flag.Slovenia": "Slowenien",
    "flag.Solomon Islands": "Salomonen",
    "flag.Somalia": "Somalia",
    "flag.South Africa": "Südafrika",
    "flag.South Korea": "Südkorea",
    "flag.South Sudan": "Südsudan",
    "flag.Spain": "Spanien",
    "flag.Sri Lanka": "Sri Lanka",
    "flag.Sudan": "Sudan",
    "flag.Suriname": "Suriname",
    "flag.Sweden": "Schweden",
    "flag.Switzerland": "Schweiz",
    "flag.Syria": "Syrien",
    "flag.Taiwan": "Taiwan",
    "flag.Tajikistan": "Tadschikistan",
    "flag.Tanzania": "Tansania",
    "flag.Thailand": "Thailand",
    "flag.Timor-Leste": "Osttimor",
    "flag.Togo": "Togo",
    "flag.Tokelau": "Tokelau",
    "flag.Tonga": "Tonga",
    "flag.Trinidad and Tobago": "Trinidad und Tobago",
    "flag.Tunisia": "Tunesien",
    "flag.Turkey": "Türkei",
    "flag.Turkmenistan": "Turkmenistan",
    "flag.Turks and Caicos Islands": "Turks- und Caicosinseln",
    "flag.Tuvalu": "Tuvalu",
    "flag.Uganda": "Uganda",
    "flag.Ukraine": "Ukraine",
    "flag.United Arab Emirates": "Vereinigte Arabische Emirate",
    "flag.United Kingdom": "Vereinigtes Königreich",
    "flag.United States": "Vereinigte Staaten",
    "flag.Uruguay": "Uruguay",
    "flag.Uzbekistan": "Usbekistan",
    "flag.Vanuatu": "Vanuatu",
    "flag.Vatican City": "Vatikanstadt",
    "flag.Venezuela": "Venezuela",
    "flag.Vietnam": "Vietnam",
    "flag.Wales": "Wales",
    "flag.Wallis and Futuna": "Wallis und Futuna",
    "flag.Western Sahara": "Westsahara",
    "flag.Yemen": "Jemen",
    "flag.Zambia": "Sambia",
    "flag.Zimbabwe": "Simbabwe",
    "flag.Guam": "Guam",
    "flag.U.S. Virgin Islands": "Amerikanische Jungferninseln",
    "flag.South Georgia and South Sandwich Islands":
      "Südgeorgien und die Südlichen Sandwichinseln",
    "flag.Curacao": "Curaçao",
    "flag.Ascension Island": "Ascension",
  },

  fr: {
    appTitle: "FlagIQ",
    appSubtitle: "Teste tes connaissances du monde — un drapeau à la fois",
    homeInfoTitle: "Comment jouer",
    homeInfoBody:
      "🎯 Objectif : Identifie le bon pays pour chaque drapeau. Plus tu es rapide et précis, meilleur est ton score.\n\n🎮 Modes de jeu :\n• Mode Classique: joue à ton rythme sans pression de temps.\n• Contre-la-montre: course contre la montre où vitesse et précision comptent ; des réponses correctes plus rapides donnent un meilleur score.\n• Drapeaux locaux: explore des packs régionaux comme les États américains et maîtrise les drapeaux locaux.\n\n❤️ Système de vies : Tu perds une vie chaque fois que tu échoues à terminer un niveau. Les vies se rechargent automatiquement avec le temps.\n\n💡 Indices et boosters :\n• Retirer 2: supprime deux options incorrectes.\n• Passage auto: termine instantanément le drapeau et te fait avancer.\n• Pause du minuteur: gèle le chrono en Contre-la-montre pendant 3 secondes.\n\n⭐ Étoiles et progression : Gagne jusqu'à trois étoiles par niveau selon ta performance. Cumule des étoiles pour débloquer de nouveaux niveaux, régions et packs spéciaux de drapeaux.\n\n🪙 Pièces et récompenses : Terminer un niveau pour la première fois donne des pièces. Dépense-les dans la boutique en indices et boosters pour avancer plus vite.\n\n🎁 Booster quotidien : Ouvre une boîte gratuite toutes les 24 heures pour recevoir des indices et des boosters.",
    homeLeaderboardTitle: "Classement",
    homeLeaderboardBody:
      "Le classement mondial arrive bientôt. Reste connecté pour les classements compétitifs.",
    leaderboardTopLabel: "Top 100 joueurs • Total des points",
    leaderboardLoading: "Chargement du classement...",
    leaderboardError: "Impossible de charger le classement pour le moment.",
    leaderboardEmpty: "Pas encore de scores Contre-la-montre.",
    leaderboardLoginRequired:
      "Le classement est disponible uniquement pour les utilisateurs connectés.",
    "homeInfo.goal.title": "Objectif",
    "homeInfo.goal.body": "Identifiez le bon pays pour chaque drapeau. Plus vous êtes rapide et précis, meilleur est votre score.",
    "homeInfo.modes.title": "Modes de jeu",
    "homeInfo.modes.classic": "Mode Classique : jouez à votre rythme, sans pression du temps.",
    "homeInfo.modes.timetrial": "Contre-la-montre : courez contre le chrono ; vitesse et précision comptent.",
    "homeInfo.modes.local": "Drapeaux locaux : explorez des packs régionaux comme les États américains et maîtrisez leurs drapeaux.",
    "homeInfo.lives.title": "Système de vies",
    "homeInfo.lives.body": "Vous perdez une vie à chaque échec de niveau. Les vies se rechargent automatiquement avec le temps.",
    "homeInfo.hints.title": "Indices et boosters",
    "homeInfo.hints.remove2.label": "Retirer 2",
    "homeInfo.hints.remove2.body": "Élimine deux mauvaises options.",
    "homeInfo.hints.autopass.label": "Passe auto",
    "homeInfo.hints.autopass.body": "Valide instantanément le drapeau et vous fait avancer.",
    "homeInfo.hints.pause.label": "Pause chrono",
    "homeInfo.hints.pause.body": "Fige le chronomètre du contre-la-montre pendant 3 secondes.",
    "homeInfo.stars.title": "Étoiles et progression",
    "homeInfo.stars.body": "Gagnez jusqu'à trois étoiles par niveau selon vos performances. Collectez des étoiles pour débloquer de nouveaux niveaux, régions et packs spéciaux.",
    "homeInfo.coins.title": "Pièces et récompenses",
    "homeInfo.coins.body": "Terminer un niveau pour la première fois rapporte des pièces. Dépensez-les dans la boutique pour avancer plus vite.",
    "homeInfo.daily.title": "Booster quotidien",
    "homeInfo.daily.body": "Ouvrez une boîte booster gratuite toutes les 24 heures pour obtenir des indices et bonus.",
    "leaderboard.attempts.one": "{{count}} tentative",
    "leaderboard.attempts.other": "{{count}} tentatives",

    classic: "Classique",
    classicDesc: "Apprends les drapeaux à ton rythme",
    timeTrial: "Contre-la-montre",
    timeTrialDesc: "Bats le chrono !",
    comingSoon: "Bientôt",
    localFlags: "Drapeaux locaux",
    localFlagsDesc: "Réservé aux joueurs experts",
    "localFlags.packType.all": "Pack complet",
    "localFlags.packType.country": "Pack pays",
    "localFlags.packs.all.name": "Tous les drapeaux locaux",
    "localFlags.packs.all.short": "Tous",
    "localFlags.packs.ch.name": "Suisse",
    "localFlags.packs.de.name": "Allemagne",
    "localFlags.packs.es.name": "Espagne",
    "localFlags.packs.gb.name": "Royaume-Uni",
    "localFlags.packs.us.name": "États-Unis",

    spinForHintsTitle: "Booster quotidien",
    spinOncePerDay: "Choisis une boîte une fois toutes les 24 heures",
    youWon: "Tu as gagné",
    claim: "Récupérer",

    selectLevel: "Choisir un niveau",
    totalStars: "Total",
    locked: "Verrouillé",
    needMoreStars:
      "Tu as besoin de plus d’étoiles pour déverrouiller cette section.",
    back: "Retour",

    profileSettings: "Profil et réglages",
    sound: "Son",
    soundEffectsTitle: "Effets sonores",
    soundEffectsSubtitle: "Activer l’audio pendant la partie",
    memberSince: "Membre depuis",
    volume: "Volume",
    language: "Langue",
    logout: "Se déconnecter",
    privacyPolicy: "Politique de confidentialité",
    termsAndConditions: "Conditions générales",
    areYouSure: "Es-tu sûr ?",
    close: "Fermer",
    footerTerms: "Conditions",
    footerPrivacy: "Confidentialité",
    footerContact: "Contact",
    username: "Nom d’utilisateur",
    coins: "Pièces",
    coinsEarnedMessage: "Tu as gagné 100 pièces !",
    storeExtraHeartLabel: "Cœur supplémentaire",
    storeRefillHeartsLabel: "Recharger les cœurs au maximum",
    storeHeartsFull: "Complet",
    login: "Se connecter",
    createAccount: "Créer un compte",
    playAsGuest: "Jouer en invité",
    entryAccountBenefits: "Sauvegardez votre progression, protégez vos pièces et jouez sur plusieurs appareils.",
    maybeLater: "Peut-être plus tard",
    guestPromptTitle: "Protégez votre progression",
    guestPromptBody: "Vous avez terminé {{milestone}} niveaux en invité. Créez un compte pour conserver progression, pièces et vies sur plusieurs appareils.",
    restorePurchases: "Restaurer les achats",
    restorePurchasesWorking: "Restauration des achats...",
    restorePurchasesSuccess: "Achats restaurés avec succès.",
    restorePurchasesFailed: "Impossible de restaurer les achats pour le moment.",
    deleteAccount: "Supprimer le compte",
    deleteAccountConfirmTitle: "Supprimer définitivement le compte ?",
    deleteAccountConfirmBody: "Cette action est irréversible. Votre compte sera supprimé définitivement et vous serez déconnecté.",
    deleteAccountConfirmAction: "Oui, supprimer le compte",
    cancel: "Annuler",
    deleting: "Suppression...",
    level_complete_cta_button: "Créer un compte / Se connecter",
    level_complete_cta_text: "Sauvegardez votre progression ou reprenez où vous vous êtes arrêté.",

    storeTitle: "Boutique des bonus",
    storeSubtitle:
      "Utilisez vos pièces pour acheter des indices ou obtenez plus de pièces.",
    storeYourCoins: "Vos pièces",
    coinsPillLabel: "Boutique",

    storeBoostersTitle: "Bonus contre pièces",
    storeBoostersDesc:
      "Les bonus peuvent être utilisés dans n'importe quel mode.",

    storeCoinPacksTitle: "Obtenir plus de pièces",
    storeCoinPacksDesc:
      "Choisissez un pack pour ajouter des pièces.",

    storeBuyButton: "Acheter",
    storeNotEnoughCoins: "Vous n’avez pas assez de pièces.",
    storeBoughtBundle: "Pack acheté : 1 de chaque bonus !",
    storeBoughtSingle: "Achat effectué !",
    storePurchaseCancelled: "Achat annulé.",
    storeCoinsAdded: "Achat réussi ! Pièces ajoutées à votre solde.",
    storeCoinsLabel: "pièces",

    storeRemove2Single: "Supprimer 2 (x1)",
    storePauseSingle: "Pause du minuteur (x1)",
    storeAutoPassSingle: "Auto-passage (x1)",
    storeAllBundle: "Pack triple (1 de chaque)",

    levelWord: "Niveau",

    gameOver: "Partie terminée",
    tryAgain: "Rejouer",
    levelComplete: "Niveau terminé",
    nextLevel: "Niveau suivant",
    goToShop: "Aller à la boutique",
    goToMainMenu: "Aller au menu principal",
    timeTrialComplete: "Défi chronométré terminé",
    finalScore: "Score final",
    score: "Score",

    "hint.title": "Comment fonctionnent les indices 💡",
    "hint.subtitle": "Utilise-les pour t’aider sur les drapeaux difficiles :",
    "hints.removeTwo.label": "Retirer 2",
    "hints.removeTwo.description": "Retire deux mauvaises réponses.",
    "hints.autoPass.label": "Passage auto",
    "hints.autoPass.description": "Choisit la bonne réponse pour toi.",
    "hints.pauseTimer.label": "Pause",
    "hints.pauseTimer.description": "Met le chrono en pause pendant 3 secondes (mode chrono uniquement).",
    "hints.bundleAll.label": "Pack triple (1 de chaque)",
    "hint.remove2Label": "Retirer 2",
    "hint.remove2Desc": "Retire deux mauvaises réponses.",
    "hint.autoPassLabel": "Passage auto",
    "hint.autoPassDesc": "Choisit la bonne réponse pour toi.",
    "hint.pauseLabel": "Pause",
    "hint.pauseDesc":
      "Met le chrono en pause pendant 3 secondes (mode chrono uniquement).",
    "hint.button": "Indices",
    "hint.info": "À quoi servent les indices ?",
    "hint.notEnough": "Pas assez d’indices.",
    ok: "Compris",
    loading: "Chargement…",
    loadingChoices: "Chargement des choix…",

    dailySpin: "Booster quotidien",
    readyToSpin: "Prêt à tourner",
    comeBackIn: "Reviens dans",
    spinForHints: "Roue des bonus",
    spinEveryDay: "Tournez une fois toutes les 24 heures",
    spinInfoTitle: "Comment ça marche",
    spinInfoBody:
      "Choisis une boîte une fois par jour pour des boosts d’indices gratuits.",
    spinToReveal: " ",
    spinNow: "Tourner maintenant",
    spinning: "En rotation…",

    "auth.welcome": "Bienvenue sur FlagIQ",
    "auth.loginTab": "Connexion",
    "auth.signupTab": "Créer un compte",

    "auth.emailOrUsername": "E-mail ou nom d’utilisateur",
    "auth.emailOrUsernamePlaceholder":
      "Entrez votre e-mail ou nom d’utilisateur",

    "auth.password": "Mot de passe",
    "auth.passwordPlaceholder": "Entrez votre mot de passe",

    "auth.username": "Nom d’utilisateur",
    "auth.usernamePlaceholder": "Choisissez un nom d’utilisateur",
    "auth.usernameHint": "Minimum 6 caractères.",

    "auth.email": "E-mail",
    "auth.emailPlaceholder": "Entrez votre e-mail",
    "auth.emailRequired": "L'adresse e-mail est obligatoire.",
    "auth.emailInvalid": "Veuillez entrer une adresse e-mail valide.",

    "auth.show": "Afficher",
    "auth.hide": "Masquer",
    "auth.forgot": "Mot de passe oublié ?",
    "auth.keepSignedIn": "Rester connecté",
    "auth.keepSignedInHelper": "Recommandé sur les appareils personnels.",
    "auth.passwordHint":
      "Au moins 6 caractères, 1 majuscule, 1 minuscule, 1 caractère spécial.",

    "auth.passwordConfirm": "Confirmer le mot de passe",
"auth.resetTitle": "Réinitialiser votre mot de passe",
"auth.resetIntro": "Choisissez un nouveau mot de passe pour votre compte FlagIQ.",
"auth.resetSubmit": "Enregistrer le nouveau mot de passe",
"auth.resetSuccess": "Votre mot de passe a été mis à jour. Vous pouvez maintenant revenir à l’application et vous connecter.",
"auth.resetMismatch": "Les mots de passe ne correspondent pas.",
"auth.passwordRequired": "Veuillez saisir votre nouveau mot de passe.",
"auth.loadingRecoveryLink": "Chargement du lien de récupération…",
"auth.resetError": "Impossible de mettre à jour votre mot de passe. Le lien a peut-être expiré.",
"auth.passwordReuseError": "Vous ne pouvez pas réutiliser un ancien mot de passe. Veuillez en choisir un nouveau.",
        "auth.resetInvalid": "Ce lien de réinitialisation est invalide ou a expiré.",
        "auth.resetNeutral": "Veuillez utiliser le lien de réinitialisation du mot de passe envoyé par e-mail.",
    "auth.passwordPlaceholder2": "Saisissez à nouveau votre nouveau mot de passe",



    // erreurs
    "auth.missingCredentials": "Veuillez entrer vos identifiants.",
    "auth.userNotFound": "Utilisateur introuvable.",
    "auth.invalidPassword": "Mot de passe incorrect.",
    "auth.usernameTooShort":
      "Le nom d’utilisateur doit contenir au moins 6 caractères.",
    "auth.usernameTaken": "Ce nom d’utilisateur est déjà pris.",
    "auth.emailInvalid": "Veuillez entrer une adresse e-mail valide.",
    "auth.passwordTooShort":
      "Le mot de passe doit contenir au moins 6 caractères.",
    "auth.passwordNeedUpper":
      "Le mot de passe doit contenir au moins une lettre majuscule.",
    "auth.passwordNeedLower":
      "Le mot de passe doit contenir au moins une lettre minuscule.",
    "auth.passwordNeedSpecial":
      "Le mot de passe doit contenir au moins un caractère spécial.",

        "auth.resetInfo":
      "Saisis ton e-mail et nous t’enverrons un lien pour réinitialiser ton mot de passe.",
    "auth.resetEmailSent":
      "Si un compte existe avec cet e-mail, tu recevras bientôt un lien de réinitialisation.",
    "auth.resetError":
      "Impossible d’envoyer le lien de réinitialisation. Merci de réessayer.",
    "auth.sendResetLink": "Envoyer le lien de réinitialisation",
    "auth.backToLogin": "Retour à la connexion",


    "flag.Afghanistan": "Afghanistan",
    "flag.Albania": "Albanie",
    "flag.Algeria": "Algérie",
    "flag.American Samoa": "Samoa américaines",
    "flag.Andorra": "Andorre",
    "flag.Angola": "Angola",
    "flag.Anguilla": "Anguilla",
    "flag.Antarctica": "Antarctique",
    "flag.Antigua and Barbuda": "Antigua-et-Barbuda",
    "flag.Argentina": "Argentine",
    "flag.Armenia": "Arménie",
    "flag.Aruba": "Aruba",
    "flag.Australia": "Australie",
    "flag.Austria": "Autriche",
    "flag.Azerbaijan": "Azerbaïdjan",
    "flag.Bahamas": "Bahamas",
    "flag.Bahrain": "Bahreïn",
    "flag.Bangladesh": "Bangladesh",
    "flag.Barbados": "Barbade",
    "flag.Belarus": "Biélorussie",
    "flag.Belgium": "Belgique",
    "flag.Belize": "Belize",
    "flag.Benin": "Bénin",
    "flag.Bermuda": "Bermudes",
    "flag.Bhutan": "Bhoutan",
    "flag.Bolivia": "Bolivie",
    "flag.Bonaire": "Bonaire",
    "flag.Bosnia and Herzegovina": "Bosnie-Herzégovine",
    "flag.Botswana": "Botswana",
    "flag.Brazil": "Brésil",
    "flag.British Indian Ocean Territory":
      "Territoire britannique de l’océan Indien",
    "flag.British Virgin Islands": "Îles Vierges britanniques",
    "flag.Brunei": "Brunei",
    "flag.Bulgaria": "Bulgarie",
    "flag.Burkina Faso": "Burkina Faso",
    "flag.Burundi": "Burundi",
    "flag.Cambodia": "Cambodge",
    "flag.Cameroon": "Cameroun",
    "flag.Canada": "Canada",
    "flag.Cape Verde": "Cap-Vert",
    "flag.Cayman Islands": "Îles Caïmans",
    "flag.Central African Republic": "République centrafricaine",
    "flag.Chad": "Tchad",
    "flag.Chile": "Chili",
    "flag.China": "Chine",
    "flag.Christmas Island": "Île Christmas",
    "flag.Cocos (Keeling) Islands": "Îles Cocos",
    "flag.Colombia": "Colombie",
    "flag.Comoros": "Comores",
    "flag.Congo (DRC)": "République démocratique du Congo",
    "flag.Congo (Republic)": "République du Congo",
    "flag.Cook Islands": "Îles Cook",
    "flag.Costa Rica": "Costa Rica",
    "flag.Croatia": "Croatie",
    "flag.Cuba": "Cuba",
    "flag.Curaçao": "Curaçao",
    "flag.Cyprus": "Chypre",
    "flag.Czech Republic": "République tchèque",
    "flag.Denmark": "Danemark",
    "flag.Djibouti": "Djibouti",
    "flag.Dominica": "Dominique",
    "flag.Dominican Republic": "République dominicaine",
    "flag.Ecuador": "Équateur",
    "flag.Egypt": "Égypte",
    "flag.El Salvador": "El Salvador",
    "flag.England": "Angleterre",
    "flag.Equatorial Guinea": "Guinée équatoriale",
    "flag.Eritrea": "Érythrée",
    "flag.Estonia": "Estonie",
    "flag.Eswatini": "Eswatini",
    "flag.Ethiopia": "Éthiopie",
    "flag.Falkland Islands": "Îles Malouines",
    "flag.Faroe Islands": "Îles Féroé",
    "flag.Fiji": "Fidji",
    "flag.Finland": "Finlande",
    "flag.France": "France",
    "flag.French Guiana": "Guyane française",
    "flag.French Polynesia": "Polynésie française",
    "flag.Gabon": "Gabon",
    "flag.Gambia": "Gambie",
    "flag.Georgia": "Géorgie",
    "flag.Germany": "Allemagne",
    "flag.Ghana": "Ghana",
    "flag.Gibraltar": "Gibraltar",
    "flag.Greece": "Grèce",
    "flag.Greenland": "Groenland",
    "flag.Grenada": "Grenade",
    "flag.Guadeloupe": "Guadeloupe",
    "flag.Guatemala": "Guatemala",
    "flag.Guernsey": "Guernesey",
    "flag.Guinea": "Guinée",
    "flag.Guinea-Bissau": "Guinée-Bissau",
    "flag.Guyana": "Guyana",
    "flag.Haiti": "Haïti",
    "flag.Honduras": "Honduras",
    "flag.Hong Kong": "Hong Kong",
    "flag.Hungary": "Hongrie",
    "flag.Iceland": "Islande",
    "flag.India": "Inde",
    "flag.Indonesia": "Indonésie",
    "flag.Iran": "Iran",
    "flag.Iraq": "Irak",
    "flag.Ireland": "Irlande",
    "flag.Isle of Man": "Île de Man",
    "flag.Israel": "Israël",
    "flag.Italy": "Italie",
    "flag.Ivory Coast": "Côte d’Ivoire",
    "flag.Jamaica": "Jamaïque",
    "flag.Japan": "Japon",
    "flag.Jersey": "Jersey",
    "flag.Jordan": "Jordanie",
    "flag.Kazakhstan": "Kazakhstan",
    "flag.Kenya": "Kenya",
    "flag.Kiribati": "Kiribati",
    "flag.Kosovo": "Kosovo",
    "flag.Kuwait": "Koweït",
    "flag.Kyrgyzstan": "Kirghizistan",
    "flag.Laos": "Laos",
    "flag.Latvia": "Lettonie",
    "flag.Lebanon": "Liban",
    "flag.Lesotho": "Lesotho",
    "flag.Liberia": "Libéria",
    "flag.Libya": "Libye",
    "flag.Liechtenstein": "Liechtenstein",
    "flag.Lithuania": "Lituanie",
    "flag.Luxembourg": "Luxembourg",
    "flag.Macau": "Macao",
    "flag.Madagascar": "Madagascar",
    "flag.Malawi": "Malawi",
    "flag.Malaysia": "Malaisie",
    "flag.Maldives": "Maldives",
    "flag.Mali": "Mali",
    "flag.Malta": "Malte",
    "flag.Marshall Islands": "Îles Marshall",
    "flag.Martinique": "Martinique",
    "flag.Mauritania": "Mauritanie",
    "flag.Mauritius": "Maurice",
    "flag.Mayotte": "Mayotte",
    "flag.Mexico": "Mexique",
    "flag.Micronesia": "Micronésie",
    "flag.Moldova": "Moldavie",
    "flag.Monaco": "Monaco",
    "flag.Mongolia": "Mongolie",
    "flag.Montenegro": "Monténégro",
    "flag.Montserrat": "Montserrat",
    "flag.Morocco": "Maroc",
    "flag.Mozambique": "Mozambique",
    "flag.Myanmar": "Myanmar",
    "flag.Namibia": "Namibie",
    "flag.Nauru": "Nauru",
    "flag.Nepal": "Népal",
    "flag.Netherlands": "Pays-Bas",
    "flag.New Caledonia": "Nouvelle-Calédonie",
    "flag.New Zealand": "Nouvelle-Zélande",
    "flag.Nicaragua": "Nicaragua",
    "flag.Niger": "Niger",
    "flag.Nigeria": "Nigéria",
    "flag.Niue": "Niue",
    "flag.Norfolk Island": "Île Norfolk",
    "flag.North Korea": "Corée du Nord",
    "flag.North Macedonia": "Macédoine du Nord",
    "flag.Northern Ireland": "Irlande du Nord",
    "flag.Northern Mariana Islands": "Îles Mariannes du Nord",
    "flag.Norway": "Norvège",
    "flag.Oman": "Oman",
    "flag.Pakistan": "Pakistan",
    "flag.Palau": "Palaos",
    "flag.Palestine": "Palestine",
    "flag.Panama": "Panama",
    "flag.Papua New Guinea": "Papouasie-Nouvelle-Guinée",
    "flag.Paraguay": "Paraguay",
    "flag.Peru": "Pérou",
    "flag.Philippines": "Philippines",
    "flag.Pitcairn Islands": "Îles Pitcairn",
    "flag.Poland": "Pologne",
    "flag.Portugal": "Portugal",
    "flag.Puerto Rico": "Porto Rico",
    "flag.Qatar": "Qatar",
    "flag.Reunion": "La Réunion",
    "flag.Romania": "Roumanie",
    "flag.Russia": "Russie",
    "flag.Rwanda": "Rwanda",
    "flag.Saint Barthélemy": "Saint-Barthélemy",
    "flag.Saint Helena": "Sainte-Hélène",
    "flag.Saint Kitts and Nevis": "Saint-Christophe-et-Niévès",
    "flag.Saint Lucia": "Sainte-Lucie",
    "flag.Saint Martin": "Saint-Martin",
    "flag.Saint Pierre and Miquelon": "Saint-Pierre-et-Miquelon",
    "flag.Saint Vincent and the Grenadines": "Saint-Vincent-et-les-Grenadines",
    "flag.Samoa": "Samoa",
    "flag.San Marino": "Saint-Marin",
    "flag.Sao Tome and Principe": "Sao Tomé-et-Principe",
    "flag.Saudi Arabia": "Arabie saoudite",
    "flag.Scotland": "Écosse",
    "flag.Senegal": "Sénégal",
    "flag.Serbia": "Serbie",
    "flag.Seychelles": "Seychelles",
    "flag.Sierra Leone": "Sierra Leone",
    "flag.Singapore": "Singapour",
    "flag.Sint Maarten": "Saint-Martin (Pays-Bas)",
    "flag.Slovakia": "Slovaquie",
    "flag.Slovenia": "Slovénie",
    "flag.Solomon Islands": "Îles Salomon",
    "flag.Somalia": "Somalie",
    "flag.South Africa": "Afrique du Sud",
    "flag.South Korea": "Corée du Sud",
    "flag.South Sudan": "Soudan du Sud",
    "flag.Spain": "Espagne",
    "flag.Sri Lanka": "Sri Lanka",
    "flag.Sudan": "Soudan",
    "flag.Suriname": "Suriname",
    "flag.Sweden": "Suède",
    "flag.Switzerland": "Suisse",
    "flag.Syria": "Syrie",
    "flag.Taiwan": "Taïwan",
    "flag.Tajikistan": "Tadjikistan",
    "flag.Tanzania": "Tanzanie",
    "flag.Thailand": "Thaïlande",
    "flag.Timor-Leste": "Timor oriental",
    "flag.Togo": "Togo",
    "flag.Tokelau": "Tokelau",
    "flag.Tonga": "Tonga",
    "flag.Trinidad and Tobago": "Trinité-et-Tobago",
    "flag.Tunisia": "Tunisie",
    "flag.Turkey": "Turquie",
    "flag.Turkmenistan": "Turkménistan",
    "flag.Turks and Caicos Islands": "Îles Turques-et-Caïques",
    "flag.Tuvalu": "Tuvalu",
    "flag.Uganda": "Ouganda",
    "flag.Ukraine": "Ukraine",
    "flag.United Arab Emirates": "Émirats arabes unis",
    "flag.United Kingdom": "Royaume-Uni",
    "flag.United States": "États-Unis",
    "flag.Uruguay": "Uruguay",
    "flag.Uzbekistan": "Ouzbékistan",
    "flag.Vanuatu": "Vanuatu",
    "flag.Vatican City": "Vatican",
    "flag.Venezuela": "Venezuela",
    "flag.Vietnam": "Viêt Nam",
    "flag.Wales": "Pays de Galles",
    "flag.Wallis and Futuna": "Wallis-et-Futuna",
    "flag.Western Sahara": "Sahara occidental",
    "flag.Yemen": "Yémen",
    "flag.Zambia": "Zambie",
    "flag.Zimbabwe": "Zimbabwe",
    "flag.Guam": "Guam",
    "flag.U.S. Virgin Islands": "Îles Vierges des États-Unis",
    "flag.South Georgia and South Sandwich Islands":
      "Géorgie du Sud-et-les îles Sandwich du Sud",
    "flag.Curacao": "Curaçao",
    "flag.Ascension Island": "Île de l'Ascension",
  },

  nl: {
    appTitle: "FlagIQ",
    appSubtitle: "Test je wereldkennis — vlag voor vlag",
    homeInfoTitle: "Zo speel je",
    homeInfoBody:
      "🎯 Doel: Kies het juiste land bij elke vlag. Hoe sneller en nauwkeuriger je bent, hoe beter je score.\n\n🎮 Spelmodi:\n• Klassieke modus: speel op je eigen tempo zonder tijdsdruk.\n• Tijdrit: race tegen de klok waarbij snelheid en nauwkeurigheid tellen; snellere juiste antwoorden leveren hogere scores op.\n• Lokale vlaggen: verken regionale pakketten zoals Amerikaanse staten en leer lokale vlaggen.\n\n❤️ Levenssysteem: Je verliest één leven wanneer je een level niet succesvol voltooit. Levens vullen zich automatisch weer aan na verloop van tijd.\n\n💡 Hints en boosters:\n• Verwijder 2: verwijdert twee foute opties.\n• Auto-pass: voltooit de vlag direct en laat je doorgaan.\n• Pauze-timer: bevriest de Tijdrit-klok 3 seconden.\n\n⭐ Sterren en voortgang: Verdien tot drie sterren per level op basis van je prestaties. Verzamel sterren om nieuwe levels, regio’s en speciale vlaggenpacks te ontgrendelen.\n\n🪙 Munten en beloningen: Een level voor het eerst voltooien levert munten op. Geef ze uit in de winkel aan hints en boosters om sneller vooruit te komen.\n\n🎁 Dagelijkse booster: Open elke 24 uur een gratis doosje om hints en boosts te ontvangen.",
    homeLeaderboardTitle: "Ranglijst",
    homeLeaderboardBody:
      "De wereldwijde ranglijst komt eraan. Blijf op de hoogte voor competitieve rankings.",
    leaderboardTopLabel: "Top 100 spelers • Totaal aantal punten",
    leaderboardLoading: "Ranglijst laden...",
    leaderboardError: "Kan de ranglijst momenteel niet laden.",
    leaderboardEmpty: "Nog geen Tijdrit-scores.",
    leaderboardLoginRequired:
      "De ranglijst is alleen beschikbaar voor ingelogde gebruikers.",
    "homeInfo.goal.title": "Doel",
    "homeInfo.goal.body": "Kies voor elke vlag het juiste land. Hoe sneller en nauwkeuriger je bent, hoe hoger je score.",
    "homeInfo.modes.title": "Spelmodi",
    "homeInfo.modes.classic": "Klassieke modus: speel op je eigen tempo zonder tijdsdruk.",
    "homeInfo.modes.timetrial": "Tijdrit: race tegen de klok; snelheid en nauwkeurigheid tellen mee.",
    "homeInfo.modes.local": "Lokale vlaggen: verken regionale pakketten zoals Amerikaanse staten en leer hun vlaggen.",
    "homeInfo.lives.title": "Levenssysteem",
    "homeInfo.lives.body": "Je verliest één leven wanneer je een level niet succesvol afrondt. Levens vullen na verloop van tijd automatisch aan.",
    "homeInfo.hints.title": "Hints en boosters",
    "homeInfo.hints.remove2.label": "Verwijder 2",
    "homeInfo.hints.remove2.body": "Verwijdert twee onjuiste opties.",
    "homeInfo.hints.autopass.label": "Auto-pas",
    "homeInfo.hints.autopass.body": "Voltooit de vlag direct en laat je doorgaan.",
    "homeInfo.hints.pause.label": "Timer pauzeren",
    "homeInfo.hints.pause.body": "Bevriest de tijdritklok gedurende 3 seconden.",
    "homeInfo.stars.title": "Sterren en voortgang",
    "homeInfo.stars.body": "Verdien tot drie sterren per level op basis van je prestatie. Verzamel sterren om nieuwe levels, regio's en speciale pakketten vrij te spelen.",
    "homeInfo.coins.title": "Munten en beloningen",
    "homeInfo.coins.body": "Een level voor de eerste keer voltooien levert munten op. Geef ze uit in de winkel aan hints en boosters om sneller vooruit te komen.",
    "homeInfo.daily.title": "Dagelijkse booster",
    "homeInfo.daily.body": "Open elke 24 uur een gratis boosterbox om hints en boosts te ontvangen.",
    "leaderboard.attempts.one": "{{count}} poging",
    "leaderboard.attempts.other": "{{count}} pogingen",

    classic: "Klassiek",
    classicDesc: "Leer vlaggen in je eigen tempo",
    timeTrial: "Tijdrit",
    timeTrialDesc: "Versla de timer!",
    comingSoon: "Binnenkort",
    localFlags: "Lokale vlaggen",
    localFlagsDesc: "Alleen voor ervaren spelers",
    "localFlags.packType.all": "Totaal pakket",
    "localFlags.packType.country": "Landpakket",
    "localFlags.packs.all.name": "Alle lokale vlaggen",
    "localFlags.packs.all.short": "Alle",
    "localFlags.packs.ch.name": "Zwitserland",
    "localFlags.packs.de.name": "Duitsland",
    "localFlags.packs.es.name": "Spanje",
    "localFlags.packs.gb.name": "Verenigd Koninkrijk",
    "localFlags.packs.us.name": "Verenigde Staten",

    selectLevel: "Kies een level",
    totalStars: "Totaal",
    locked: "Geblokkeerd",
    needMoreStars: "Je hebt meer sterren nodig om dit deel te ontgrendelen.",
    back: "Terug",

    spinForHintsTitle: "Dagelijkse booster",
    youWon: "Je hebt gewonnen",
    spinOncePerDay: "Kies één keer per 24 uur een doosje",
    claim: "Ophalen",

    coins: "Munten",
    coinsEarnedMessage: "Je hebt 100 munten verdiend!",

    profileSettings: "Profiel & instellingen",
    sound: "Geluid",
    soundEffectsTitle: "Geluidseffecten",
    soundEffectsSubtitle: "Audio afspelen tijdens het spelen",
    memberSince: "Lid sinds",
    volume: "Volume",
    language: "Taal",
    logout: "Uitloggen",
    privacyPolicy: "Privacybeleid",
    termsAndConditions: "Algemene voorwaarden",
    areYouSure: "Weet je het zeker?",
    close: "Sluiten",
    footerTerms: "Voorwaarden",
    footerPrivacy: "Privacy",
    footerContact: "Contact",
    username: "Gebruikersnaam",
    coinsPillLabel: "Winkel",

    login: "Inloggen",
    createAccount: "Account maken",
    playAsGuest: "Als gast spelen",
    entryAccountBenefits: "Sla je voortgang op, houd je munten veilig en speel op meerdere apparaten.",
    maybeLater: "Misschien later",
    guestPromptTitle: "Houd je voortgang veilig",
    guestPromptBody: "Je hebt {{milestone}} levels als gast voltooid. Maak een account om voortgang, munten en levens op meerdere apparaten te bewaren.",
    restorePurchases: "Aankopen herstellen",
    restorePurchasesWorking: "Aankopen herstellen...",
    restorePurchasesSuccess: "Aankopen succesvol hersteld.",
    restorePurchasesFailed: "Aankopen kunnen nu niet worden hersteld.",
    deleteAccount: "Account verwijderen",
    deleteAccountConfirmTitle: "Account permanent verwijderen?",
    deleteAccountConfirmBody: "Deze actie kan niet ongedaan worden gemaakt. Je account wordt permanent verwijderd en je wordt uitgelogd.",
    deleteAccountConfirmAction: "Ja, account verwijderen",
    cancel: "Annuleren",
    deleting: "Bezig met verwijderen...",
    level_complete_cta_button: "Account maken / Inloggen",
    level_complete_cta_text: "Sla je voortgang op of ga verder waar je gebleven was.",

    storeTitle: "Booster-shop",
    storeSubtitle: "Besteed munten aan hints of koop meer munten.",
    storeYourCoins: "Je munten",
    storeBoostersTitle: "Boosters kopen met munten",
    storeBoostersDesc: "Booster-hints werken in elke modus.",
    storeCoinPacksTitle: "Meer munten krijgen",
    storeCoinPacksDesc:
      "Kies een pakket om munten toe te voegen.",

    storeBuyButton: "Kopen",
    storeNotEnoughCoins: "Onvoldoende munten.",
    storeBoughtBundle: "Je hebt 1 van elke hint gekocht!",
    storeBoughtSingle: "Aankoop geslaagd!",
    storePurchaseCancelled: "Aankoop geannuleerd.",
    storeCoinsAdded: "Aankoop geslaagd! Munten toegevoegd aan je saldo.",
    storeCoinsLabel: "munten",
    storeExtraHeartLabel: "Extra hart",
    storeRefillHeartsLabel: "Harten volledig aanvullen",
    storeHeartsFull: "Vol",

    storeRemove2Single: "Verwijder 2 (x1)",
    storePauseSingle: "Timer pauzeren (x1)",
    storeAutoPassSingle: "Auto-pass (x1)",
    storeAllBundle: "Triple-pack (1 van elke)",

    levelWord: "Level",

    gameOver: "Game over",
    tryAgain: "Opnieuw proberen",
    levelComplete: "Level voltooid",
    nextLevel: "Volgend level",
    goToShop: "Naar de winkel",
    goToMainMenu: "Naar het hoofdmenu",
    timeTrialComplete: "Tijdrit voltooid",
    finalScore: "Eindscore",
    score: "Score",

    "hint.title": "Zo werken hints 💡",
    "hint.subtitle": "Gebruik ze bij lastige vlaggen:",
    "hints.removeTwo.label": "Verwijder 2",
    "hints.removeTwo.description": "Verwijdert twee foute antwoorden.",
    "hints.autoPass.label": "Auto-pass",
    "hints.autoPass.description": "Kiest het juiste antwoord voor je.",
    "hints.pauseTimer.label": "Pauze",
    "hints.pauseTimer.description": "Pauzeert de timer 3 seconden (alleen Tijdspel).",
    "hints.bundleAll.label": "Drievoudig pakket (1 van elk)",
    "hint.remove2Label": "Verwijder 2",
    "hint.remove2Desc": "Verwijdert twee foute antwoorden.",
    "hint.autoPassLabel": "Auto-pass",
    "hint.autoPassDesc": "Kiest het juiste antwoord voor je.",
    "hint.pauseLabel": "Pauze",
    "hint.pauseDesc": "Pauzeert de timer 3 seconden (alleen Tijdspel).",
    "hint.button": "Hints",
    "hint.info": "Wat doen de hints?",
    "hint.notEnough": "Niet genoeg hints.",
    ok: "Oké",
    loading: "Laden…",
    loadingChoices: "Keuzes laden…",

    dailySpin: "Dagelijkse booster",
    readyToSpin: "Klaar om te draaien",
    comeBackIn: "Kom terug over",
    spinForHints: "Boosterwiel",
    spinEveryDay: "Draai één keer per 24 uur",
    spinInfoTitle: "Hoe het werkt",
    spinInfoBody:
      "Kies één keer per dag een doosje voor gratis hint-boosts.",
    spinToReveal: " ",
    spinNow: "Nu draaien",
    spinning: "Aan het draaien…",

    "auth.welcome": "Welkom bij FlagIQ",
    "auth.loginTab": "Inloggen",
    "auth.signupTab": "Account aanmaken",

    "auth.emailOrUsername": "E-mail of gebruikersnaam",
    "auth.emailOrUsernamePlaceholder": "Vul je e-mail of gebruikersnaam in",

    "auth.password": "Wachtwoord",
    "auth.passwordPlaceholder": "Vul je wachtwoord in",

    "auth.username": "Gebruikersnaam",
    "auth.usernamePlaceholder": "Kies een gebruikersnaam",
    "auth.usernameHint": "Minimaal 6 tekens.",

    "auth.email": "E-mail",
    "auth.emailPlaceholder": "Vul je e-mail in",
    "auth.emailRequired": "E-mailadres is verplicht.",
    "auth.emailInvalid": "Voer een geldig e-mailadres in.",

    "auth.show": "Tonen",
    "auth.hide": "Verbergen",
    "auth.forgot": "Wachtwoord vergeten?",
    "auth.keepSignedIn": "Aangemeld blijven",
    "auth.keepSignedInHelper": "Aanbevolen op persoonlijke apparaten.",
    "auth.passwordHint":
      "Minimaal 6 tekens, 1 hoofdletter, 1 kleine letter, 1 speciaal teken.",

    "auth.passwordConfirm": "Wachtwoord bevestigen",
"auth.resetTitle": "Stel een nieuw wachtwoord in",
"auth.resetIntro": "Kies een nieuw wachtwoord voor je FlagIQ-account.",
"auth.resetSubmit": "Nieuw wachtwoord opslaan",
"auth.resetSuccess": "Je wachtwoord is bijgewerkt. Je kunt nu terug naar de app en inloggen.",
"auth.resetMismatch": "De wachtwoorden komen niet overeen.",
"auth.passwordRequired": "Vul je nieuwe wachtwoord in.",
"auth.loadingRecoveryLink": "Herstellink laden…",
"auth.resetError": "Je wachtwoord kon niet worden bijgewerkt. De link is mogelijk verlopen.",
"auth.passwordReuseError": "Je kunt geen eerder wachtwoord gebruiken. Kies een nieuw wachtwoord.",
        "auth.resetInvalid": "Deze resetlink is ongeldig of verlopen.",
    "auth.resetNeutral": "Gebruik de wachtwoordresetlink uit je e-mail.",
  "auth.passwordPlaceholder2": "Voer je nieuwe wachtwoord opnieuw in",



    // fouten
    "auth.missingCredentials": "Voer je gegevens in.",
    "auth.userNotFound": "Gebruiker niet gevonden.",
    "auth.invalidPassword": "Onjuist wachtwoord.",
    "auth.usernameTooShort": "Gebruikersnaam moet minstens 6 tekens hebben.",
    "auth.usernameTaken": "Deze gebruikersnaam is al in gebruik.",
    "auth.emailInvalid": "Voer een geldig e-mailadres in.",
    "auth.passwordTooShort": "Wachtwoord moet minstens 6 tekens hebben.",
    "auth.passwordNeedUpper":
      "Wachtwoord moet minstens één hoofdletter bevatten.",
    "auth.passwordNeedLower":
      "Wachtwoord moet minstens één kleine letter bevatten.",
    "auth.passwordNeedSpecial":
      "Wachtwoord moet minstens één speciaal teken bevatten.",

        "auth.resetInfo":
      "Vul je e-mail in en we sturen je een link om je wachtwoord te resetten.",
    "auth.resetEmailSent":
      "Als er een account bestaat met dat e-mailadres, ontvang je binnenkort een resetlink.",
    "auth.resetError":
      "De resetlink kon niet worden verzonden. Probeer het opnieuw.",
    "auth.sendResetLink": "Resetlink verzenden",
    "auth.backToLogin": "Terug naar inloggen",


    "flag.Afghanistan": "Afghanistan",
    "flag.Albania": "Albanië",
    "flag.Algeria": "Algerije",
    "flag.American Samoa": "Amerikaans-Samoa",
    "flag.Andorra": "Andorra",
    "flag.Angola": "Angola",
    "flag.Anguilla": "Anguilla",
    "flag.Antarctica": "Antarctica",
    "flag.Antigua and Barbuda": "Antigua en Barbuda",
    "flag.Argentina": "Argentinië",
    "flag.Armenia": "Armenië",
    "flag.Aruba": "Aruba",
    "flag.Australia": "Australië",
    "flag.Austria": "Oostenrijk",
    "flag.Azerbaijan": "Azerbeidzjan",
    "flag.Bahamas": "Bahama's",
    "flag.Bahrain": "Bahrein",
    "flag.Bangladesh": "Bangladesh",
    "flag.Barbados": "Barbados",
    "flag.Belarus": "Wit-Rusland",
    "flag.Belgium": "België",
    "flag.Belize": "Belize",
    "flag.Benin": "Benin",
    "flag.Bermuda": "Bermuda",
    "flag.Bhutan": "Bhutan",
    "flag.Bolivia": "Bolivia",
    "flag.Bonaire": "Bonaire",
    "flag.Bosnia and Herzegovina": "Bosnië en Herzegovina",
    "flag.Botswana": "Botswana",
    "flag.Brazil": "Brazilië",
    "flag.British Indian Ocean Territory": "Brits Indische Oceaanterritorium",
    "flag.British Virgin Islands": "Britse Maagdeneilanden",
    "flag.Brunei": "Brunei",
    "flag.Bulgaria": "Bulgarije",
    "flag.Burkina Faso": "Burkina Faso",
    "flag.Burundi": "Burundi",
    "flag.Cambodia": "Cambodja",
    "flag.Cameroon": "Kameroen",
    "flag.Canada": "Canada",
    "flag.Cape Verde": "Kaapverdië",
    "flag.Cayman Islands": "Kaaimaneilanden",
    "flag.Central African Republic": "Centraal-Afrikaanse Republiek",
    "flag.Chad": "Tsjaad",
    "flag.Chile": "Chili",
    "flag.China": "China",
    "flag.Christmas Island": "Christmaseiland",
    "flag.Cocos (Keeling) Islands": "Cocoseilanden",
    "flag.Colombia": "Colombia",
    "flag.Comoros": "Comoren",
    "flag.Congo (DRC)": "Democratische Republiek Congo",
    "flag.Congo (Republic)": "Republiek Congo",
    "flag.Cook Islands": "Cookeilanden",
    "flag.Costa Rica": "Costa Rica",
    "flag.Croatia": "Kroatië",
    "flag.Cuba": "Cuba",
    "flag.Curaçao": "Curaçao",
    "flag.Cyprus": "Cyprus",
    "flag.Czech Republic": "Tsjechië",
    "flag.Denmark": "Denemarken",
    "flag.Djibouti": "Djibouti",
    "flag.Dominica": "Dominica",
    "flag.Dominican Republic": "Dominicaanse Republiek",
    "flag.Ecuador": "Ecuador",
    "flag.Egypt": "Egypte",
    "flag.El Salvador": "El Salvador",
    "flag.England": "Engeland",
    "flag.Equatorial Guinea": "Equatoriaal-Guinea",
    "flag.Eritrea": "Eritrea",
    "flag.Estonia": "Estland",
    "flag.Eswatini": "Eswatini",
    "flag.Ethiopia": "Ethiopië",
    "flag.Falkland Islands": "Falklandeilanden",
    "flag.Faroe Islands": "Faeröer",
    "flag.Fiji": "Fiji",
    "flag.Finland": "Finland",
    "flag.France": "Frankrijk",
    "flag.French Guiana": "Frans-Guyana",
    "flag.French Polynesia": "Frans-Polynesië",
    "flag.Gabon": "Gabon",
    "flag.Gambia": "Gambia",
    "flag.Georgia": "Georgië",
    "flag.Germany": "Duitsland",
    "flag.Ghana": "Ghana",
    "flag.Gibraltar": "Gibraltar",
    "flag.Greece": "Griekenland",
    "flag.Greenland": "Groenland",
    "flag.Grenada": "Grenada",
    "flag.Guadeloupe": "Guadeloupe",
    "flag.Guatemala": "Guatemala",
    "flag.Guernsey": "Guernsey",
    "flag.Guinea": "Guinee",
    "flag.Guinea-Bissau": "Guinee-Bissau",
    "flag.Guyana": "Guyana",
    "flag.Haiti": "Haïti",
    "flag.Honduras": "Honduras",
    "flag.Hong Kong": "Hongkong",
    "flag.Hungary": "Hongarije",
    "flag.Iceland": "IJsland",
    "flag.India": "India",
    "flag.Indonesia": "Indonesië",
    "flag.Iran": "Iran",
    "flag.Iraq": "Irak",
    "flag.Ireland": "Ierland",
    "flag.Isle of Man": "Isle of Man",
    "flag.Israel": "Israël",
    "flag.Italy": "Italië",
    "flag.Ivory Coast": "Ivoorkust",
    "flag.Jamaica": "Jamaica",
    "flag.Japan": "Japan",
    "flag.Jersey": "Jersey",
    "flag.Jordan": "Jordanië",
    "flag.Kazakhstan": "Kazachstan",
    "flag.Kenya": "Kenia",
    "flag.Kiribati": "Kiribati",
    "flag.Kosovo": "Kosovo",
    "flag.Kuwait": "Koeweit",
    "flag.Kyrgyzstan": "Kirgizië",
    "flag.Laos": "Laos",
    "flag.Latvia": "Letland",
    "flag.Lebanon": "Libanon",
    "flag.Lesotho": "Lesotho",
    "flag.Liberia": "Liberia",
    "flag.Libya": "Libië",
    "flag.Liechtenstein": "Liechtenstein",
    "flag.Lithuania": "Litouwen",
    "flag.Luxembourg": "Luxemburg",
    "flag.Macau": "Macau",
    "flag.Madagascar": "Madagaskar",
    "flag.Malawi": "Malawi",
    "flag.Malaysia": "Maleisië",
    "flag.Maldives": "Maldiven",
    "flag.Mali": "Mali",
    "flag.Malta": "Malta",
    "flag.Marshall Islands": "Marshalleilanden",
    "flag.Martinique": "Martinique",
    "flag.Mauritania": "Mauritanië",
    "flag.Mauritius": "Mauritius",
    "flag.Mayotte": "Mayotte",
    "flag.Mexico": "Mexico",
    "flag.Micronesia": "Micronesië",
    "flag.Moldova": "Moldavië",
    "flag.Monaco": "Monaco",
    "flag.Mongolia": "Mongolië",
    "flag.Montenegro": "Montenegro",
    "flag.Montserrat": "Montserrat",
    "flag.Morocco": "Marokko",
    "flag.Mozambique": "Mozambique",
    "flag.Myanmar": "Myanmar",
    "flag.Namibia": "Namibië",
    "flag.Nauru": "Nauru",
    "flag.Nepal": "Nepal",
    "flag.Netherlands": "Nederland",
    "flag.New Caledonia": "Nieuw-Caledonië",
    "flag.New Zealand": "Nieuw-Zeeland",
    "flag.Nicaragua": "Nicaragua",
    "flag.Niger": "Niger",
    "flag.Nigeria": "Nigeria",
    "flag.Niue": "Niue",
    "flag.Norfolk Island": "Norfolkeiland",
    "flag.North Korea": "Noord-Korea",
    "flag.North Macedonia": "Noord-Macedonië",
    "flag.Northern Ireland": "Noord-Ierland",
    "flag.Northern Mariana Islands": "Noordelijke Marianen",
    "flag.Norway": "Noorwegen",
    "flag.Oman": "Oman",
    "flag.Pakistan": "Pakistan",
    "flag.Palau": "Palau",
    "flag.Palestine": "Palestina",
    "flag.Panama": "Panama",
    "flag.Papua New Guinea": "Papoea-Nieuw-Guinea",
    "flag.Paraguay": "Paraguay",
    "flag.Peru": "Peru",
    "flag.Philippines": "Filipijnen",
    "flag.Pitcairn Islands": "Pitcairneilanden",
    "flag.Poland": "Polen",
    "flag.Portugal": "Portugal",
    "flag.Puerto Rico": "Puerto Rico",
    "flag.Qatar": "Qatar",
    "flag.Reunion": "Réunion",
    "flag.Romania": "Roemenië",
    "flag.Russia": "Rusland",
    "flag.Rwanda": "Rwanda",
    "flag.Saint Barthélemy": "Saint-Barthélemy",
    "flag.Saint Helena": "Sint-Helena",
    "flag.Saint Kitts and Nevis": "Saint Kitts en Nevis",
    "flag.Saint Lucia": "Saint Lucia",
    "flag.Saint Martin": "Sint-Maarten (Frans)",
    "flag.Saint Pierre and Miquelon": "Saint-Pierre en Miquelon",
    "flag.Saint Vincent and the Grenadines": "Saint Vincent en de Grenadines",
    "flag.Samoa": "Samoa",
    "flag.San Marino": "San Marino",
    "flag.Sao Tome and Principe": "Sao Tomé en Principe",
    "flag.Saudi Arabia": "Saoedi-Arabië",
    "flag.Scotland": "Schotland",
    "flag.Senegal": "Senegal",
    "flag.Serbia": "Servië",
    "flag.Seychelles": "Seychellen",
    "flag.Sierra Leone": "Sierra Leone",
    "flag.Singapore": "Singapore",
    "flag.Sint Maarten": "Sint Maarten",
    "flag.Slovakia": "Slowakije",
    "flag.Slovenia": "Slovenië",
    "flag.Solomon Islands": "Salomonseilanden",
    "flag.Somalia": "Somalië",
    "flag.South Africa": "Zuid-Afrika",
    "flag.South Korea": "Zuid-Korea",
    "flag.South Sudan": "Zuid-Soedan",
    "flag.Spain": "Spanje",
    "flag.Sri Lanka": "Sri Lanka",
    "flag.Sudan": "Soedan",
    "flag.Suriname": "Suriname",
    "flag.Sweden": "Zweden",
    "flag.Switzerland": "Zwitserland",
    "flag.Syria": "Syrië",
    "flag.Taiwan": "Taiwan",
    "flag.Tajikistan": "Tadzjikistan",
    "flag.Tanzania": "Tanzania",
    "flag.Thailand": "Thailand",
    "flag.Timor-Leste": "Oost-Timor",
    "flag.Togo": "Togo",
    "flag.Tokelau": "Tokelau",
    "flag.Tonga": "Tonga",
    "flag.Trinidad and Tobago": "Trinidad en Tobago",
    "flag.Tunisia": "Tunesië",
    "flag.Turkey": "Turkije",
    "flag.Turkmenistan": "Turkmenistan",
    "flag.Turks and Caicos Islands": "Turks- en Caicoseilanden",
    "flag.Tuvalu": "Tuvalu",
    "flag.Uganda": "Oeganda",
    "flag.Ukraine": "Oekraïne",
    "flag.United Arab Emirates": "Verenigde Arabische Emiraten",
    "flag.United Kingdom": "Verenigd Koninkrijk",
    "flag.United States": "Verenigde Staten",
    "flag.Uruguay": "Uruguay",
    "flag.Uzbekistan": "Oezbekistan",
    "flag.Vanuatu": "Vanuatu",
    "flag.Vatican City": "Vaticaanstad",
    "flag.Venezuela": "Venezuela",
    "flag.Vietnam": "Vietnam",
    "flag.Wales": "Wales",
    "flag.Wallis and Futuna": "Wallis en Futuna",
    "flag.Western Sahara": "Westelijke Sahara",
    "flag.Yemen": "Jemen",
    "flag.Zambia": "Zambia",
    "flag.Zimbabwe": "Zimbabwe",
    "flag.Guam": "Guam",
    "flag.U.S. Virgin Islands": "Amerikaanse Maagdeneilanden",
    "flag.South Georgia and South Sandwich Islands":
      "Zuid-Georgia en de Zuidelijke Sandwicheilanden",
    "flag.Curacao": "Curaçao",
    "flag.Ascension Island": "Ascension",
  },
};

const LEGACY_HINT_KEYS = new Set([
  "hint.remove2Label",
  "hint.remove2Desc",
  "hint.autoPassLabel",
  "hint.autoPassDesc",
  "hint.pauseLabel",
  "hint.pauseDesc",
  "homeInfo.hints.remove2.label",
  "homeInfo.hints.remove2.body",
  "homeInfo.hints.autopass.label",
  "homeInfo.hints.autopass.body",
  "homeInfo.hints.pause.label",
  "homeInfo.hints.pause.body",
  "storeRemove2Single",
  "storePauseSingle",
  "storeAutoPassSingle",
]);

const warnedLegacyHintKeys = new Set();

export function t(lang, key) {
  const pack = STRINGS[lang] || STRINGS.en;
  const value = pack[key] || STRINGS.en[key] || key;
  if (process.env.NODE_ENV !== "production" && LEGACY_HINT_KEYS.has(key) && !warnedLegacyHintKeys.has(key)) {
    warnedLegacyHintKeys.add(key);
    console.warn(`[i18n] Legacy hint translation key requested: ${key}`);
  }
  return value;
}

function interpolate(template, vars = {}) {
  if (typeof template !== "string") return template;
  return template.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, token) =>
    Object.prototype.hasOwnProperty.call(vars, token) ? String(vars[token]) : ""
  );
}

export function ti(lang, key, vars = {}) {
  return interpolate(t(lang, key), vars);
}

export function tp(lang, key, count, vars = {}) {
  const pluralKey = count === 1 ? `${key}.one` : `${key}.other`;
  return interpolate(t(lang, pluralKey), { ...vars, count });
}



